import React from 'react';
export const ForwardIcon = (props) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3333 11C18.3333 10.4937 17.9229 10.0833 17.4166 10.0833H4.58331C4.07705 10.0833 3.66665 10.4937 3.66665 11C3.66665 11.5063 4.07705 11.9167 4.58331 11.9167H17.4166C17.9229 11.9167 18.3333 11.5063 18.3333 11Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3518 3.93514C9.99382 4.29312 9.99382 4.87352 10.3518 5.2315L16.1203 11L10.3518 16.7685C9.99382 17.1265 9.99382 17.7069 10.3518 18.0648C10.7098 18.4228 11.2902 18.4228 11.6482 18.0648L18.0648 11.6482C18.4228 11.2902 18.4228 10.7098 18.0648 10.3518L11.6482 3.93514C11.2902 3.57716 10.7098 3.57716 10.3518 3.93514Z"
        fill="white"
      />
    </svg>
  );
};

export const BackIcon = (props) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.66669 11C3.66669 10.4937 4.07709 10.0833 4.58335 10.0833H17.4167C17.9229 10.0833 18.3334 10.4937 18.3334 11C18.3334 11.5063 17.9229 11.9167 17.4167 11.9167H4.58335C4.07709 11.9167 3.66669 11.5063 3.66669 11Z"
        fill="#273747"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6482 3.93514C12.0062 4.29312 12.0062 4.87352 11.6482 5.2315L5.87972 11L11.6482 16.7685C12.0062 17.1265 12.0062 17.7069 11.6482 18.0648C11.2902 18.4228 10.7098 18.4228 10.3518 18.0648L3.93517 11.6482C3.57719 11.2902 3.57719 10.7098 3.93517 10.3518L10.3518 3.93514C10.7098 3.57716 11.2902 3.57716 11.6482 3.93514Z"
        fill="#273747"
      />
    </svg>
  );
};

export const PlusIcon = (props) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0003 3.66669C11.5066 3.66669 11.917 4.07709 11.917 4.58335V10.0834H17.417C17.9233 10.0834 18.3337 10.4938 18.3337 11C18.3337 11.5063 17.9233 11.9167 17.417 11.9167H11.917V17.4167C11.917 17.9229 11.5066 18.3334 11.0003 18.3334C10.4941 18.3334 10.0837 17.9229 10.0837 17.4167V11.9167H4.58366C4.0774 11.9167 3.66699 11.5063 3.66699 11C3.66699 10.4938 4.0774 10.0834 4.58366 10.0834H10.0837V4.58335C10.0837 4.07709 10.4941 3.66669 11.0003 3.66669Z"
        fill="white"
      />
    </svg>
  );
};

export const PlusGreyIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.9987 3.33301C10.4589 3.33301 10.832 3.7061 10.832 4.16634V9.16634H15.832C16.2923 9.16634 16.6654 9.53944 16.6654 9.99967C16.6654 10.4599 16.2923 10.833 15.832 10.833H10.832V15.833C10.832 16.2932 10.4589 16.6663 9.9987 16.6663C9.53846 16.6663 9.16536 16.2932 9.16536 15.833V10.833H4.16536C3.70513 10.833 3.33203 10.4599 3.33203 9.99967C3.33203 9.53944 3.70513 9.16634 4.16536 9.16634H9.16536V4.16634C9.16536 3.7061 9.53846 3.33301 9.9987 3.33301Z"
        fill="#7F8A9D"
      />
    </svg>
  );
};

export const BellIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M12.0035 4C15.4207 4 17.8723 6.79005 17.8723 10.4099V11.7713C17.8723 11.9659 18.0368 12.2239 18.4855 12.6868C18.5431 12.7462 18.5973 12.8013 18.7156 12.9211C19.6359 13.8544 20 14.3921 20 15.2572C20 15.6355 19.9559 15.9304 19.7722 16.2838C19.3839 17.0307 18.5608 17.4468 17.3303 17.4468L15.7033 17.4477C15.1678 19.4328 13.8902 20.5108 12 20.5108C10.0897 20.5108 8.80504 19.4097 8.27983 17.3839L8.29617 17.4468H6.66965C5.40331 17.4468 4.57136 17.0193 4.19971 16.2463C4.0372 15.9082 4 15.6339 4 15.2572C4 14.3921 4.36415 13.8544 5.28436 12.9211C5.40272 12.8013 5.4569 12.7462 5.51445 12.6868C5.96319 12.2239 6.12766 11.9659 6.12766 11.7713V10.4099C6.12766 6.79146 8.58529 4 12.0035 4ZM14.0987 17.4484H9.90131C10.2893 18.5094 10.9581 18.9789 12 18.9789C13.0419 18.9789 13.7107 18.5094 14.0987 17.4484ZM12.0035 5.53192C9.47784 5.53192 7.65957 7.59717 7.65957 10.4099V11.7713C7.65957 12.4968 7.32813 13.0167 6.61447 13.753C6.55212 13.8174 6.49326 13.8771 6.37522 13.9967C5.73957 14.6414 5.53192 14.948 5.53192 15.2572C5.53192 15.4207 5.54344 15.5057 5.58036 15.5825C5.67168 15.7725 5.94886 15.9149 6.66965 15.9149H17.3303C18.0283 15.9149 18.3119 15.7715 18.4129 15.5772C18.455 15.4962 18.4681 15.4089 18.4681 15.2572C18.4681 14.948 18.2604 14.6414 17.6248 13.9967C17.5067 13.8771 17.4479 13.8174 17.3855 13.753C16.6719 13.0167 16.3404 12.4968 16.3404 11.7713V10.4099C16.3404 7.59519 14.5274 5.53192 12.0035 5.53192Z"
          fill="#CBD0D7"
        />
      </g>
    </svg>
  );
};

export const MailIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.60606 6H8.5756H8.57557C7.92261 5.99999 7.3886 5.99999 6.9546 6.03544C6.50538 6.07215 6.09966 6.15044 5.72076 6.3435C5.12776 6.64564 4.64564 7.12776 4.3435 7.72076C4.15044 8.09966 4.07215 8.50538 4.03544 8.9546C3.99999 9.3886 3.99999 9.92261 4 10.5756V10.5756V10.6061V14.1616V14.1921V14.1921C3.99999 14.8451 3.99999 15.3791 4.03544 15.8131C4.07215 16.2623 4.15044 16.668 4.3435 17.0469C4.64564 17.6399 5.12776 18.122 5.72076 18.4242C6.09966 18.6172 6.50538 18.6955 6.9546 18.7322C7.3886 18.7677 7.92262 18.7677 8.57559 18.7677H8.60606H15.3939H15.4244C16.0774 18.7677 16.6114 18.7677 17.0454 18.7322C17.4946 18.6955 17.9003 18.6172 18.2792 18.4242C18.8722 18.122 19.3544 17.6399 19.6565 17.0469C19.8496 16.668 19.9279 16.2623 19.9646 15.8131C20 15.3791 20 14.8451 20 14.1921V14.1616V10.6061V10.5756C20 9.92262 20 9.3886 19.9646 8.9546C19.9279 8.50538 19.8496 8.09966 19.6565 7.72076C19.3544 7.12776 18.8722 6.64564 18.2792 6.3435C17.9003 6.15044 17.4946 6.07215 17.0454 6.03544C16.6114 5.99999 16.0774 5.99999 15.4244 6H15.4244H15.3939H8.60606ZM6.65102 7.54518C6.76057 7.51985 6.8968 7.49956 7.07305 7.48516C7.44081 7.45511 7.91521 7.45455 8.60606 7.45455H15.3939C16.0848 7.45455 16.5592 7.45511 16.927 7.48516C17.1032 7.49956 17.2394 7.51985 17.349 7.54518L14.1093 10.3799C13.6424 10.7884 13.3227 11.0675 13.0565 11.2666C12.7976 11.4602 12.6329 11.5439 12.4904 11.586C12.1703 11.6807 11.8297 11.6807 11.5096 11.586C11.3671 11.5439 11.2024 11.4602 10.9435 11.2666C10.6773 11.0675 10.3576 10.7884 9.89066 10.3799L6.65102 7.54518ZM5.57608 8.53737C5.53605 8.66317 5.50501 8.83009 5.48516 9.07305C5.45511 9.44081 5.45455 9.91521 5.45455 10.6061V14.1616C5.45455 14.8525 5.45511 15.3269 5.48516 15.6946C5.51451 16.0539 5.56834 16.2469 5.6395 16.3866C5.8022 16.7059 6.0618 16.9655 6.38111 17.1282C6.52078 17.1993 6.71377 17.2532 7.07305 17.2825C7.44081 17.3126 7.91521 17.3131 8.60606 17.3131H15.3939C16.0848 17.3131 16.5592 17.3126 16.927 17.2825C17.2862 17.2532 17.4792 17.1993 17.6189 17.1282C17.9382 16.9655 18.1978 16.7059 18.3605 16.3866C18.4317 16.2469 18.4855 16.0539 18.5148 15.6946C18.5449 15.3269 18.5455 14.8525 18.5455 14.1616V10.6061C18.5455 9.91521 18.5449 9.44081 18.5148 9.07305C18.495 8.83009 18.4639 8.66317 18.4239 8.53736L15.0672 11.4745L15.046 11.4931C14.6055 11.8785 14.2439 12.1949 13.9276 12.4314C13.599 12.6772 13.2764 12.8704 12.9029 12.9808C12.3136 13.1551 11.6864 13.1551 11.0971 12.9808C10.7236 12.8704 10.401 12.6772 10.0724 12.4314C9.75612 12.1949 9.39456 11.8785 8.95406 11.4931L8.93283 11.4745L5.57608 8.53737Z"
          fill="#CBD0D7"
        />
      </g>
    </svg>
  );
};

export const ArrowDown = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="chevron_left_small_20">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.7803 7.71967C14.4874 7.42678 14.0126 7.42678 13.7197 7.71967L10 11.4393L6.28033 7.71967C5.98743 7.42678 5.51256 7.42678 5.21967 7.71967C4.92678 8.01257 4.92678 8.48744 5.21967 8.78033L9.46969 13.0303C9.76259 13.3232 10.2375 13.3232 10.5304 13.0303L14.7803 8.78033C15.0732 8.48743 15.0732 8.01256 14.7803 7.71967Z"
          fill="#BAC0CD"
        />
      </g>
    </svg>
  );
};

export const UndoIcon = (props) => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.78033 2.46967C8.07322 2.76256 8.07322 3.23744 7.78033 3.53033L5.31066 6H12.5C13.4946 6 14.4484 6.39509 15.1517 7.09835C15.8549 7.80161 16.25 8.75544 16.25 9.75V15C16.25 15.4142 15.9142 15.75 15.5 15.75C15.0858 15.75 14.75 15.4142 14.75 15V9.75C14.75 9.15326 14.5129 8.58097 14.091 8.15901C13.669 7.73705 13.0967 7.5 12.5 7.5H5.31066L7.78033 9.96967C8.07322 10.2626 8.07322 10.7374 7.78033 11.0303C7.48744 11.3232 7.01256 11.3232 6.71967 11.0303L2.96967 7.28033C2.67678 6.98744 2.67678 6.51256 2.96967 6.21967L6.71967 2.46967C7.01256 2.17678 7.48744 2.17678 7.78033 2.46967Z"
          fill="#7F8A9D"
        />
      </g>
    </svg>
  );
};

export const RedoIcon = (props) => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.2197 2.46967C10.9268 2.76256 10.9268 3.23744 11.2197 3.53033L13.6893 6H6.5C5.50544 6 4.55161 6.39509 3.84835 7.09835C3.14509 7.80161 2.75 8.75544 2.75 9.75V15C2.75 15.4142 3.08579 15.75 3.5 15.75C3.91421 15.75 4.25 15.4142 4.25 15V9.75C4.25 9.15326 4.48705 8.58097 4.90901 8.15901C5.33097 7.73705 5.90326 7.5 6.5 7.5H13.6893L11.2197 9.96967C10.9268 10.2626 10.9268 10.7374 11.2197 11.0303C11.5126 11.3232 11.9874 11.3232 12.2803 11.0303L16.0303 7.28033C16.3232 6.98744 16.3232 6.51256 16.0303 6.21967L12.2803 2.46967C11.9874 2.17678 11.5126 2.17678 11.2197 2.46967Z"
          fill="#7F8A9D"
        />
      </g>
    </svg>
  );
};

export const HotSpotIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.77212 0.243585C6.07623 0.440112 6.2769 0.700366 6.38305 1.04888C6.40678 1.1692 6.41339 1.27767 6.41333 1.40023C6.41344 1.44649 6.41356 1.49276 6.41367 1.54044C6.41351 1.59093 6.41334 1.64143 6.41317 1.69346C6.41321 1.74736 6.41326 1.80126 6.41331 1.85679C6.41341 2.03781 6.41309 2.21883 6.41278 2.39986C6.41276 2.52946 6.41277 2.65905 6.4128 2.78865C6.41282 3.1409 6.41248 3.49315 6.41208 3.8454C6.41172 4.21336 6.41168 4.58133 6.41162 4.94929C6.41146 5.56704 6.4111 6.18478 6.41058 6.80253C6.41005 7.4388 6.40964 8.07508 6.4094 8.71135C6.40938 8.75057 6.40937 8.7898 6.40935 8.83021C6.40928 9.02697 6.40921 9.22373 6.40913 9.42049C6.40854 11.0528 6.40752 12.6851 6.40623 14.3173C6.46094 14.326 6.51564 14.3347 6.572 14.3436C6.80598 14.3844 6.98867 14.4736 7.19887 14.5805C7.2396 14.6012 7.28034 14.6219 7.32231 14.6432C7.6678 14.8239 7.96383 15.033 8.25091 15.2979C8.30293 15.3447 8.35495 15.3914 8.40854 15.4396C9.01065 16.008 9.40863 16.6539 9.69207 17.432C11.7688 17.3807 13.7924 16.0898 15.1933 14.6354C16.4597 13.2824 17.2091 11.5207 17.4743 9.703C17.4151 9.67921 17.3559 9.65541 17.2948 9.6309C16.7857 9.42088 16.345 9.19222 15.9179 8.83781C15.8688 8.7981 15.8198 8.7584 15.7692 8.71749C14.7848 7.88057 14.2236 6.70641 14.0732 5.43473C13.9938 4.01877 14.3958 2.70342 15.3414 1.62789C15.3798 1.58395 15.4182 1.54 15.4578 1.49473C16.2865 0.607069 17.5291 0.064891 18.7333 0.00115099C20.2457 -0.0277518 21.5398 0.487808 22.6445 1.53416C23.4183 2.34286 23.9407 3.50531 23.9883 4.62722C23.9928 4.70183 23.9928 4.70183 23.9973 4.77795C24.041 6.12386 23.5453 7.35723 22.6733 8.36556C22.2396 8.82019 21.7575 9.15991 21.1997 9.44344C21.1421 9.47274 21.1421 9.47274 21.0834 9.50263C20.8611 9.61054 20.6598 9.67561 20.4143 9.703C20.4058 9.77572 20.3973 9.84843 20.3886 9.92335C20.1455 11.8736 19.4559 13.8231 18.2814 15.4133C18.2371 15.4738 18.1929 15.5343 18.1474 15.5967C17.8399 16.0105 17.5082 16.3972 17.1522 16.7699C17.0982 16.8265 17.0445 16.8834 16.9912 16.9406C15.1415 18.9205 12.4261 20.1535 9.74971 20.4314C9.73077 20.4844 9.71182 20.5375 9.69229 20.5922C9.19303 21.9414 8.29269 22.9707 6.98382 23.5895C5.85243 24.0567 4.45116 24.1591 3.29334 23.7191C2.75506 23.493 2.25611 23.2128 1.79454 22.8539C1.7608 22.8296 1.72706 22.8053 1.6923 22.7802C0.716603 22.0262 0.185065 20.7653 0.0255172 19.5765C-0.098663 18.3123 0.230452 17.011 1.01175 15.9993C1.62997 15.2548 2.41622 14.6091 3.35098 14.3173C3.40805 14.3173 3.46512 14.3173 3.52392 14.3173C3.52371 14.2504 3.5235 14.1835 3.52328 14.1145C3.51828 12.5239 3.51448 10.9334 3.51215 9.34281C3.51186 9.14687 3.51156 8.95094 3.51126 8.75501C3.5112 8.716 3.51113 8.677 3.51107 8.63681C3.51007 8.00592 3.50825 7.37503 3.50613 6.74415C3.50397 6.0964 3.50271 5.44866 3.50223 4.80091C3.50193 4.43724 3.50122 4.07359 3.49954 3.70993C3.49797 3.36745 3.4975 3.02499 3.49784 2.68251C3.49778 2.557 3.49732 2.43149 3.49644 2.30598C3.49528 2.13416 3.49557 1.96239 3.49619 1.79056C3.49552 1.7413 3.49485 1.69203 3.49416 1.64128C3.4988 1.16847 3.64485 0.699377 3.98509 0.358943C4.55219 -0.0727944 5.15932 -0.116544 5.77212 0.243585ZM17.3714 3.65455C16.9868 4.19637 16.892 4.71656 16.9555 5.37705C17.0712 5.96823 17.4399 6.38983 17.9031 6.75775C18.3457 7.04421 18.8606 7.1092 19.3766 7.04975C19.9733 6.90866 20.4711 6.57766 20.8178 6.0692C21.1142 5.51014 21.2048 4.94645 21.0412 4.3244C20.8548 3.78389 20.4203 3.32098 19.9225 3.04734C19.0162 2.66864 18.0012 2.90029 17.3714 3.65455ZM3.40863 17.6051C2.97822 18.1805 2.81715 18.6742 2.88981 19.3931C3.0297 19.9904 3.36238 20.4881 3.8698 20.8351C4.40555 21.1239 4.94988 21.2163 5.54514 21.0586C6.13874 20.8585 6.60104 20.4535 6.88902 19.8978C7.12077 19.4099 7.11819 18.8164 6.95027 18.308C6.72744 17.7779 6.38896 17.4183 5.88742 17.1436C5.85338 17.124 5.81935 17.1044 5.78428 17.0842C5.02301 16.7218 3.94716 16.9764 3.40863 17.6051Z"
        fill="#64748B"
      />
    </svg>
  );
};

export const TextInputIcon = (props) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame 10537">
        <g id="Vector">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.9643 17.5761C10.9643 17.1577 11.2752 16.8185 11.6587 16.8185H17.6772C18.0608 16.8185 18.3717 17.1577 18.3717 17.5761C18.3717 17.9945 18.0608 18.3337 17.6772 18.3337H11.6587C11.2752 18.3337 10.9643 17.9945 10.9643 17.5761Z"
            fill="#64748B"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.9828 6.21245H4.01982C3.76413 6.21245 3.55686 6.43857 3.55686 6.7175V13.7882C3.55686 14.0671 3.76413 14.2933 4.01982 14.2933H16.9828C17.2385 14.2933 17.4457 14.0671 17.4457 13.7882V6.7175C17.4457 6.43857 17.2385 6.21245 16.9828 6.21245ZM4.01982 4.6973C2.99707 4.6973 2.16797 5.60177 2.16797 6.7175L2.16797 13.7882C2.16797 14.9039 2.99707 15.8084 4.01982 15.8084H16.9828C18.0055 15.8084 18.8346 14.9039 18.8346 13.7882V6.7175C18.8346 5.60177 18.0055 4.6973 16.9828 4.6973H4.01982Z"
            fill="#64748B"
          />
          <path
            d="M6.33723 12.8378C6.25804 13.1034 6.03113 13.2832 5.77513 13.2832C5.36902 13.2832 5.08387 12.8467 5.21639 12.4279L6.64827 7.90304C6.77714 7.4958 7.12859 7.22255 7.52351 7.22255H7.71707C8.11214 7.22255 8.46369 7.496 8.59244 7.90345L10.0222 12.4281C10.1546 12.8469 9.86939 13.2832 9.46334 13.2832C9.20719 13.2832 8.98018 13.1032 8.90108 12.8374L7.64885 8.63001C7.64485 8.61658 7.63338 8.60749 7.62044 8.60749C7.6075 8.60749 7.59603 8.61658 7.59203 8.63L6.33723 12.8378ZM6.12576 11.4011C6.12576 11.1248 6.33101 10.9009 6.5842 10.9009H8.64041C8.8936 10.9009 9.09885 11.1248 9.09885 11.4011C9.09885 11.6773 8.8936 11.9012 8.64041 11.9012H6.5842C6.33101 11.9012 6.12576 11.6773 6.12576 11.4011Z"
            fill="#64748B"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.33723 12.8378C6.25804 13.1034 6.03113 13.2832 5.77513 13.2832C5.36902 13.2832 5.08387 12.8467 5.21639 12.4279L6.64827 7.90304C6.77714 7.4958 7.12859 7.22255 7.52351 7.22255H7.71707C8.11214 7.22255 8.46369 7.496 8.59244 7.90345L10.0222 12.4281C10.1546 12.8469 9.86939 13.2832 9.46334 13.2832C9.20719 13.2832 8.98018 13.1032 8.90108 12.8374L8.62243 11.9012H6.61654L6.33723 12.8378ZM6.68379 12.0022L6.42528 12.8691C6.33368 13.1762 6.07123 13.3842 5.77513 13.3842C5.3054 13.3842 4.97558 12.8793 5.12887 12.3949L6.56074 7.87007C6.7025 7.42211 7.0891 7.12154 7.52351 7.12154H7.71707C8.15164 7.12154 8.53835 7.42233 8.67998 7.87053L10.1098 12.3952C10.2628 12.8795 9.93298 13.3842 9.46334 13.3842C9.16707 13.3842 8.90451 13.176 8.81301 12.8686L8.55514 12.0022H6.68379ZM7.64885 8.63001C7.64485 8.61658 7.63338 8.60749 7.62044 8.60749C7.6075 8.60749 7.59603 8.61658 7.59203 8.63L6.91482 10.9009H8.32473L7.64885 8.63001ZM8.19732 10.7999L7.62038 8.86145L7.04231 10.7999H8.19732Z"
            fill="#64748B"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.8995 2.17204C15.283 2.17204 15.5939 2.51122 15.5939 2.92962V17.5761C15.5939 17.9945 15.283 18.3337 14.8994 18.3337C14.5159 18.3337 14.205 17.9945 14.205 17.5761L14.205 2.92962C14.205 2.51122 14.5159 2.17204 14.8995 2.17204Z"
            fill="#64748B"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.9643 2.42457C10.9643 2.00617 11.2752 1.66699 11.6587 1.66699H17.6772C18.0608 1.66699 18.3717 2.00617 18.3717 2.42457C18.3717 2.84297 18.0608 3.18214 17.6772 3.18214H11.6587C11.2752 3.18214 10.9643 2.84297 10.9643 2.42457Z"
            fill="#64748B"
          />
        </g>
      </g>
    </svg>
  );
};

export const NotesIcon = ({ fill }) => {
  const defaultFill = '#64748B';

  return (
    <svg
      width="25"
      height="20"
      viewBox="0 0 25 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M16.5 11.667H8.5C8.23478 11.667 7.98043 11.7548 7.79289 11.9111C7.60536 12.0674 7.5 12.2793 7.5 12.5003C7.5 12.7213 7.60536 12.9333 7.79289 13.0896C7.98043 13.2459 8.23478 13.3337 8.5 13.3337H16.5C16.7652 13.3337 17.0196 13.2459 17.2071 13.0896C17.3946 12.9333 17.5 12.7213 17.5 12.5003C17.5 12.2793 17.3946 12.0674 17.2071 11.9111C17.0196 11.7548 16.7652 11.667 16.5 11.667ZM16.5 8.33366H10.5C10.2348 8.33366 9.98043 8.42146 9.79289 8.57774C9.60536 8.73402 9.5 8.94598 9.5 9.16699C9.5 9.38801 9.60536 9.59997 9.79289 9.75625C9.98043 9.91253 10.2348 10.0003 10.5 10.0003H16.5C16.7652 10.0003 17.0196 9.91253 17.2071 9.75625C17.3946 9.59997 17.5 9.38801 17.5 9.16699C17.5 8.94598 17.3946 8.73402 17.2071 8.57774C17.0196 8.42146 16.7652 8.33366 16.5 8.33366ZM20.5 3.33366H17.5V2.50033C17.5 2.27931 17.3946 2.06735 17.2071 1.91107C17.0196 1.75479 16.7652 1.66699 16.5 1.66699C16.2348 1.66699 15.9804 1.75479 15.7929 1.91107C15.6054 2.06735 15.5 2.27931 15.5 2.50033V3.33366H13.5V2.50033C13.5 2.27931 13.3946 2.06735 13.2071 1.91107C13.0196 1.75479 12.7652 1.66699 12.5 1.66699C12.2348 1.66699 11.9804 1.75479 11.7929 1.91107C11.6054 2.06735 11.5 2.27931 11.5 2.50033V3.33366H9.5V2.50033C9.5 2.27931 9.39464 2.06735 9.20711 1.91107C9.01957 1.75479 8.76522 1.66699 8.5 1.66699C8.23478 1.66699 7.98043 1.75479 7.79289 1.91107C7.60536 2.06735 7.5 2.27931 7.5 2.50033V3.33366H4.5C4.23478 3.33366 3.98043 3.42146 3.79289 3.57774C3.60536 3.73402 3.5 3.94598 3.5 4.16699V15.8337C3.5 16.4967 3.81607 17.1326 4.37868 17.6014C4.94129 18.0703 5.70435 18.3337 6.5 18.3337H18.5C19.2956 18.3337 20.0587 18.0703 20.6213 17.6014C21.1839 17.1326 21.5 16.4967 21.5 15.8337V4.16699C21.5 3.94598 21.3946 3.73402 21.2071 3.57774C21.0196 3.42146 20.7652 3.33366 20.5 3.33366ZM19.5 15.8337C19.5 16.0547 19.3946 16.2666 19.2071 16.4229C19.0196 16.5792 18.7652 16.667 18.5 16.667H6.5C6.23478 16.667 5.98043 16.5792 5.79289 16.4229C5.60536 16.2666 5.5 16.0547 5.5 15.8337V5.00033H7.5V5.83366C7.5 6.05467 7.60536 6.26663 7.79289 6.42291C7.98043 6.57919 8.23478 6.66699 8.5 6.66699C8.76522 6.66699 9.01957 6.57919 9.20711 6.42291C9.39464 6.26663 9.5 6.05467 9.5 5.83366V5.00033H11.5V5.83366C11.5 6.05467 11.6054 6.26663 11.7929 6.42291C11.9804 6.57919 12.2348 6.66699 12.5 6.66699C12.7652 6.66699 13.0196 6.57919 13.2071 6.42291C13.3946 6.26663 13.5 6.05467 13.5 5.83366V5.00033H15.5V5.83366C15.5 6.05467 15.6054 6.26663 15.7929 6.42291C15.9804 6.57919 16.2348 6.66699 16.5 6.66699C16.7652 6.66699 17.0196 6.57919 17.2071 6.42291C17.3946 6.26663 17.5 6.05467 17.5 5.83366V5.00033H19.5V15.8337Z"
          fill={fill || defaultFill}
        />
      </g>
    </svg>
  );
};

export const BrushIcon = (props) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="u:brush-alt">
        <path
          id="Vector"
          d="M10.4998 14.9997C10.335 14.9997 10.1739 15.0485 10.0369 15.1401C9.89982 15.2317 9.79301 15.3618 9.72994 15.5141C9.66686 15.6664 9.65036 15.8339 9.68252 15.9956C9.71467 16.1572 9.79404 16.3057 9.91058 16.4223C10.0271 16.5388 10.1756 16.6182 10.3373 16.6503C10.4989 16.6825 10.6665 16.666 10.8187 16.6029C10.971 16.5398 11.1012 16.433 11.1927 16.296C11.2843 16.1589 11.3332 15.9978 11.3332 15.833C11.3332 15.612 11.2454 15.4 11.0891 15.2438C10.9328 15.0875 10.7209 14.9997 10.4998 14.9997ZM15.4998 0.833008H5.49984C5.27882 0.833008 5.06686 0.920805 4.91058 1.07709C4.7543 1.23337 4.6665 1.44533 4.6665 1.66634V9.16634C4.6665 9.82938 4.9299 10.4653 5.39874 10.9341C5.86758 11.4029 6.50346 11.6663 7.1665 11.6663H7.99984V13.6413C7.57553 14.1225 7.29906 14.7158 7.20361 15.3501C7.10816 15.9845 7.19778 16.6329 7.46171 17.2176C7.72565 17.8023 8.15268 18.2984 8.69158 18.6464C9.23048 18.9944 9.85835 19.1795 10.4998 19.1795C11.1413 19.1795 11.7692 18.9944 12.3081 18.6464C12.847 18.2984 13.274 17.8023 13.538 17.2176C13.8019 16.6329 13.8915 15.9845 13.7961 15.3501C13.7006 14.7158 13.4241 14.1225 12.9998 13.6413V11.6663H13.8332C14.4962 11.6663 15.1321 11.4029 15.6009 10.9341C16.0698 10.4653 16.3332 9.82938 16.3332 9.16634V1.66634C16.3332 1.44533 16.2454 1.23337 16.0891 1.07709C15.9328 0.920805 15.7209 0.833008 15.4998 0.833008ZM10.4998 17.4997C10.1645 17.4971 9.83775 17.3935 9.56225 17.2023C9.28676 17.0111 9.07534 16.7413 8.95562 16.4281C8.83591 16.1148 8.81347 15.7727 8.89123 15.4466C8.96899 15.1204 9.14335 14.8252 9.3915 14.5997C9.47783 14.5218 9.5469 14.4266 9.59426 14.3204C9.64162 14.2142 9.66623 14.0993 9.6665 13.983V11.6663H11.3332V13.983C11.3334 14.0993 11.3581 14.2142 11.4054 14.3204C11.4528 14.4266 11.5218 14.5218 11.6082 14.5997C11.8563 14.8252 12.0307 15.1204 12.1084 15.4466C12.1862 15.7727 12.1638 16.1148 12.0441 16.4281C11.9243 16.7413 11.7129 17.0111 11.4374 17.2023C11.1619 17.3935 10.8352 17.4971 10.4998 17.4997ZM14.6665 9.16634C14.6665 9.38735 14.5787 9.59932 14.4224 9.7556C14.2661 9.91188 14.0542 9.99967 13.8332 9.99967H7.1665C6.94549 9.99967 6.73353 9.91188 6.57725 9.7556C6.42097 9.59932 6.33317 9.38735 6.33317 9.16634V8.33301H14.6665V9.16634ZM14.6665 6.66634H6.33317V2.49967H14.6665V6.66634Z"
          fill="#64748B"
        />
      </g>
    </svg>
  );
};

export const LineIcon = (props) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="fi:arrow-up-right">
        <path
          id="Vector"
          d="M6.3335 14.1663L14.6668 5.83301"
          stroke="#64748B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M6.3335 5.83301H14.6668V14.1663"
          stroke="#64748B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const TextIcon = (props) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="u:text">
        <path
          id="Vector"
          d="M16.75 2.5H4.25C3.91848 2.5 3.60054 2.6317 3.36612 2.86612C3.1317 3.10054 3 3.41848 3 3.75C3 4.08152 3.1317 4.39946 3.36612 4.63388C3.60054 4.8683 3.91848 5 4.25 5H9.25V16.25C9.25 16.5815 9.3817 16.8995 9.61612 17.1339C9.85054 17.3683 10.1685 17.5 10.5 17.5C10.8315 17.5 11.1495 17.3683 11.3839 17.1339C11.6183 16.8995 11.75 16.5815 11.75 16.25V5H16.75C17.0815 5 17.3995 4.8683 17.6339 4.63388C17.8683 4.39946 18 4.08152 18 3.75C18 3.41848 17.8683 3.10054 17.6339 2.86612C17.3995 2.6317 17.0815 2.5 16.75 2.5Z"
          fill="#64748B"
        />
      </g>
    </svg>
  );
};

export const SquareIcon = (props) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="u:square-shape">
        <path
          id="Vector"
          d="M14.6665 1.66699H6.33317C5.2281 1.66699 4.16829 2.10598 3.38689 2.88738C2.60549 3.66878 2.1665 4.72859 2.1665 5.83366V14.167C2.1665 15.2721 2.60549 16.3319 3.38689 17.1133C4.16829 17.8947 5.2281 18.3337 6.33317 18.3337H14.6665C15.7716 18.3337 16.8314 17.8947 17.6128 17.1133C18.3942 16.3319 18.8332 15.2721 18.8332 14.167V5.83366C18.8332 4.72859 18.3942 3.66878 17.6128 2.88738C16.8314 2.10598 15.7716 1.66699 14.6665 1.66699ZM17.1665 14.167C17.1665 14.83 16.9031 15.4659 16.4343 15.9348C15.9654 16.4036 15.3295 16.667 14.6665 16.667H6.33317C5.67013 16.667 5.03424 16.4036 4.5654 15.9348C4.09656 15.4659 3.83317 14.83 3.83317 14.167V5.83366C3.83317 5.17062 4.09656 4.53473 4.5654 4.06589C5.03424 3.59705 5.67013 3.33366 6.33317 3.33366H14.6665C15.3295 3.33366 15.9654 3.59705 16.4343 4.06589C16.9031 4.53473 17.1665 5.17062 17.1665 5.83366V14.167Z"
          fill="#64748B"
        />
      </g>
    </svg>
  );
};

export const CropIcon = (props) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="u:crop-alt">
        <path
          id="Vector"
          d="M17.7915 14.167H16.7498V4.79199C16.7498 4.51573 16.6401 4.25077 16.4447 4.05542C16.2494 3.86007 15.9844 3.75033 15.7082 3.75033H6.33317V2.70866C6.33317 2.43239 6.22342 2.16744 6.02807 1.97209C5.83272 1.77674 5.56777 1.66699 5.2915 1.66699C5.01524 1.66699 4.75029 1.77674 4.55493 1.97209C4.35958 2.16744 4.24984 2.43239 4.24984 2.70866V3.75033H3.20817C2.9319 3.75033 2.66695 3.86007 2.4716 4.05542C2.27625 4.25077 2.1665 4.51573 2.1665 4.79199C2.1665 5.06826 2.27625 5.33321 2.4716 5.52856C2.66695 5.72391 2.9319 5.83366 3.20817 5.83366H4.24984V15.2087C4.24984 15.4849 4.35958 15.7499 4.55493 15.9452C4.75029 16.1406 5.01524 16.2503 5.2915 16.2503H14.6665V17.292C14.6665 17.5683 14.7763 17.8332 14.9716 18.0286C15.167 18.2239 15.4319 18.3337 15.7082 18.3337C15.9844 18.3337 16.2494 18.2239 16.4447 18.0286C16.6401 17.8332 16.7498 17.5683 16.7498 17.292V16.2503H17.7915C18.0678 16.2503 18.3327 16.1406 18.5281 15.9452C18.7234 15.7499 18.8332 15.4849 18.8332 15.2087C18.8332 14.9324 18.7234 14.6674 18.5281 14.4721C18.3327 14.2767 18.0678 14.167 17.7915 14.167ZM14.6665 14.167H6.33317V5.83366H14.6665V14.167Z"
          fill="#64748B"
        />
      </g>
    </svg>
  );
};

export const DropdownIcon = (props) => {
  return (
    <svg
      width="18px"
      height="22px"
      viewBox="0 0 18 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="icons-/-dropdown"
          transform="translate(-3.000000, 0.000000)"
          fill="#64748B"
        >
          <path
            d="M12.1213203,-1.58983937e-13 L14.121,2 L20,2 C20.5522847,2 21,2.44771525 21,3 L21,21 C21,21.5522847 20.5522847,22 20,22 L4,22 C3.44771525,22 3,21.5522847 3,21 L3,3 C3,2.44771525 3.44771525,2 4,2 L10.12,2 L12.1213203,-1.58983937e-13 Z M19,4 L5,4 L5,20 L19,20 L19,4 Z M16,15 L16,17 L8,17 L8,15 L16,15 Z M16,11 L16,13 L8,13 L8,11 L16,11 Z M16,7 L16,9 L8,9 L8,7 L16,7 Z"
            id="Combined-Shape"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const ArrowRight = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.21967 3.96967C6.51256 3.67678 6.98744 3.67678 7.28033 3.96967L11.7803 8.46967C12.0732 8.76256 12.0732 9.23744 11.7803 9.53033L7.28033 14.0303C6.98744 14.3232 6.51256 14.3232 6.21967 14.0303C5.92678 13.7374 5.92678 13.2626 6.21967 12.9697L10.1893 9L6.21967 5.03033C5.92678 4.73744 5.92678 4.26256 6.21967 3.96967Z"
        fill="#596780"
      />
    </svg>
  );
};

export const ThunderIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.165 0.90197C11.5044 1.04928 11.706 1.40267 11.6601 1.76975L10.9438 7.49972H17.4998C17.8232 7.49972 18.1174 7.68677 18.2545 7.97959C18.3917 8.27241 18.347 8.61814 18.14 8.86654L9.8067 18.8665C9.56987 19.1507 9.17403 19.2448 8.83469 19.0975C8.49534 18.9502 8.29373 18.5968 8.33962 18.2297L9.05586 12.4997H2.49985C2.1765 12.4997 1.88234 12.3127 1.74519 12.0199C1.60804 11.727 1.65266 11.3813 1.85966 11.1329L10.193 1.1329C10.4298 0.848706 10.8257 0.754663 11.165 0.90197ZM4.27905 10.8331H9.99985C10.2389 10.8331 10.4664 10.9357 10.6246 11.1149C10.7828 11.2941 10.8564 11.5326 10.8267 11.7698L10.346 15.616L15.7206 9.16639H9.99985C9.76082 9.16639 9.5333 9.06375 9.37512 8.88456C9.21693 8.70536 9.1433 8.46687 9.17295 8.22969L9.65373 4.38344L4.27905 10.8331Z"
        fill="#64BBCD"
      />
    </svg>
  );
};

export const HistoryIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C9.84951 20 7.83247 19.1467 6.34222 17.6559C6.08191 17.3955 6.08198 16.9734 6.34237 16.7131C6.60277 16.4528 7.02487 16.4529 7.28518 16.7133C8.52785 17.9563 10.2068 18.6667 12 18.6667C15.6819 18.6667 18.6667 15.6819 18.6667 12C18.6667 8.3181 15.6819 5.33333 12 5.33333C10.1743 5.33333 8.47351 6.07202 7.23819 7.33358L8.33333 7.33333C8.70152 7.33333 9 7.63181 9 8C9 8.34189 8.74264 8.62367 8.41108 8.66218L8.33333 8.66667H5.66667C5.32478 8.66667 5.043 8.40931 5.00449 8.07775L5 8V5.33333C5 4.96514 5.29848 4.66667 5.66667 4.66667C6.00856 4.66667 6.29034 4.92403 6.32885 5.25559L6.33333 5.33333L6.33315 6.3525C7.81117 4.86838 9.83299 4 12 4ZM12 8C12.3419 8 12.6237 8.25736 12.6622 8.58892L12.6667 8.66667V11.7239L14.4714 13.5286C14.7318 13.7889 14.7318 14.2111 14.4714 14.4714C14.2311 14.7117 13.8529 14.7302 13.5914 14.5269L13.5286 14.4714L11.5286 12.4714C11.4244 12.3672 11.3583 12.2321 11.3391 12.0876L11.3333 12V8.66667C11.3333 8.29848 11.6318 8 12 8Z"
        fill="#64748B"
      />
    </svg>
  );
};

export const CogIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7703 4.02734C13.0572 4.07324 13.3286 4.18302 13.5723 4.37797C13.9715 4.69732 14.1616 5.09988 14.3085 5.68759C14.3461 5.83805 14.4112 6.01344 14.4926 6.18367C14.6791 6.263 14.8617 6.35117 15.0397 6.44785C15.2153 6.40445 15.384 6.34682 15.5187 6.28411C16.4663 5.84294 17.2613 5.86612 17.9124 6.56832C17.9674 6.62771 18.0003 6.66706 18.0718 6.7554L18.4941 7.27689C18.6077 7.41714 18.6562 7.48104 18.7279 7.60027C19.1921 8.37292 19.0111 9.0925 18.4243 9.87224C18.3269 10.0016 18.2275 10.171 18.1443 10.3492C18.1968 10.5388 18.2405 10.731 18.2752 10.9254C18.4247 11.0452 18.5836 11.1501 18.7239 11.2217C19.2635 11.4971 19.613 11.7729 19.8344 12.2337C19.9695 12.5149 20.0154 12.8041 19.9956 13.0939C19.9851 13.2471 19.9686 13.3325 19.9244 13.5238L19.7735 14.1776C19.7293 14.3688 19.7068 14.4528 19.649 14.5951C19.5398 14.8644 19.3717 15.1041 19.127 15.2977C18.726 15.6148 18.291 15.7095 17.6853 15.7204C17.5321 15.7232 17.349 15.7466 17.1669 15.7868C17.0484 15.9504 16.9223 16.1083 16.789 16.2599C16.7913 16.4439 16.8096 16.6248 16.8409 16.7726C16.9665 17.3653 16.9721 17.8104 16.7533 18.2725C16.6197 18.5545 16.4239 18.7721 16.1862 18.9392C16.0606 19.0274 15.9838 19.0683 15.8074 19.1544L15.2043 19.4485C15.0279 19.5345 14.9484 19.5699 14.8014 19.6146C14.5235 19.6991 14.2314 19.7194 13.9269 19.651C13.4282 19.5389 13.0808 19.2605 12.6911 18.7966C12.5881 18.674 12.4474 18.5406 12.2943 18.4204C12.1965 18.4249 12.0983 18.4271 12 18.4271C11.9016 18.4271 11.8035 18.4249 11.7057 18.4204C11.5526 18.5406 11.4119 18.674 11.3088 18.7966C10.9191 19.2605 10.5718 19.5389 10.073 19.651C9.76855 19.7194 9.47651 19.6991 9.19853 19.6146C9.05159 19.5699 8.97211 19.5345 8.79571 19.4485L8.1926 19.1544C8.13957 19.1285 8.10668 19.1122 8.06826 19.0922C7.18817 18.6339 6.93016 17.8528 7.15905 16.7726C7.19038 16.6248 7.20867 16.4439 7.21096 16.2599C7.07763 16.1083 6.95152 15.9504 6.8331 15.7868C6.65097 15.7466 6.46788 15.7232 6.31466 15.7204C5.70896 15.7095 5.27396 15.6148 4.87299 15.2977C4.62822 15.1041 4.46021 14.8644 4.35095 14.5951C4.2932 14.4528 4.27064 14.3688 4.22649 14.1776L4.07554 13.5238C4.0288 13.3213 4.01158 13.231 4.00272 13.067C3.9861 12.7594 4.04495 12.4539 4.20105 12.164C4.42849 11.7417 4.76515 11.4824 5.27605 11.2217C5.41638 11.1501 5.57526 11.0452 5.72473 10.9254C5.75946 10.731 5.80315 10.5388 5.85562 10.3492C5.77245 10.171 5.67304 10.0016 5.57568 9.87224C4.98887 9.0925 4.80784 8.37292 5.2721 7.60027C5.34374 7.48104 5.39226 7.41714 5.50583 7.27689L5.92812 6.7554C5.99966 6.66706 6.03254 6.62771 6.0876 6.56832C6.73863 5.86612 7.53363 5.84294 8.48129 6.28411C8.61599 6.34682 8.78467 6.40445 8.96031 6.44785C9.13826 6.35117 9.32082 6.263 9.50741 6.18367C9.58875 6.01344 9.65384 5.83805 9.69145 5.68759C9.83838 5.09988 10.0285 4.69732 10.4277 4.37797C10.6714 4.18302 10.9427 4.07324 11.2296 4.02734C11.3509 4.00793 11.4308 4.00208 11.5584 4.00051L12.3355 4C12.5318 4 12.6187 4.00308 12.7703 4.02734ZM12.393 5.3422L11.6645 5.34206C11.329 5.34206 11.1612 5.34206 10.9934 6.01309C10.9003 6.38556 10.7038 6.8614 10.4327 7.26848C10.0015 7.40966 9.59593 7.60752 9.22486 7.85324C8.74389 7.80585 8.25852 7.66077 7.91488 7.50079C7.28782 7.20887 7.18225 7.33924 6.9711 7.59998L6.54881 8.12147C6.33766 8.38221 6.23209 8.51259 6.648 9.06525C6.8821 9.37631 7.1319 9.83686 7.27677 10.3107C7.12843 10.7129 7.02998 11.1392 6.98894 11.5821C6.65234 11.9406 6.23003 12.2416 5.88609 12.4171C5.26999 12.7315 5.30773 12.895 5.38321 13.2219L5.53415 13.8757C5.60963 14.2026 5.64737 14.3661 6.33893 14.3786C6.7213 14.3855 7.22668 14.4693 7.68292 14.6406C7.91465 15.0263 8.1966 15.3783 8.51973 15.6878C8.58305 16.1692 8.55094 16.6781 8.47196 17.0508C8.32858 17.7275 8.47936 17.801 8.78092 17.9481L9.38403 18.2423C9.68559 18.3894 9.83637 18.4629 10.2813 17.9333C10.5308 17.6364 10.9213 17.2909 11.3486 17.0433C11.5618 17.0709 11.7792 17.0851 12 17.0851C12.2207 17.0851 12.4382 17.0709 12.6514 17.0433C13.0786 17.2909 13.4692 17.6364 13.7187 17.9333C14.1636 18.4629 14.3144 18.3894 14.6159 18.2423L15.219 17.9481C15.5206 17.801 15.6714 17.7275 15.528 17.0508C15.449 16.6781 15.4169 16.1692 15.4802 15.6878C15.8034 15.3783 16.0853 15.0263 16.317 14.6406C16.7733 14.4693 17.2787 14.3855 17.661 14.3786C18.3526 14.3661 18.3903 14.2026 18.4658 13.8757L18.6168 13.2219C18.6922 12.895 18.73 12.7315 18.1139 12.4171C17.7699 12.2416 17.3476 11.9406 17.011 11.5821C16.97 11.1392 16.8715 10.7129 16.7232 10.3107C16.8681 9.83686 17.1179 9.37631 17.352 9.06525C17.7679 8.51259 17.6623 8.38221 17.4512 8.12147L17.0289 7.59998C16.8177 7.33924 16.7121 7.20887 16.0851 7.50079C15.7414 7.66077 15.2561 7.80585 14.7751 7.85324C14.404 7.60752 13.9985 7.40966 13.5673 7.26848C13.2961 6.8614 13.0996 6.38556 13.0065 6.01309C12.8486 5.38153 12.6907 5.34438 12.393 5.3422ZM12 9.03272C13.6677 9.03272 15.0196 10.3847 15.0196 12.0524C15.0196 13.72 13.6677 15.072 12 15.072C10.3323 15.072 8.98035 13.72 8.98035 12.0524C8.98035 10.3847 10.3323 9.03272 12 9.03272ZM12 10.3748C11.0735 10.3748 10.3224 11.1259 10.3224 12.0524C10.3224 12.9788 11.0735 13.7299 12 13.7299C12.9265 13.7299 13.6776 12.9788 13.6776 12.0524C13.6776 11.1259 12.9265 10.3748 12 10.3748Z"
        fill="#64748B"
      />
    </svg>
  );
};

export const EyeIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      onClick={props.onClick}
    >
      <path
        d="M12 6C16.1698 6 20 9.16984 20 11.5652C20 13.9606 16.1698 17.1304 12 17.1304C7.83022 17.1304 4 13.9606 4 11.5652C4 9.16984 7.83022 6 12 6ZM12 7.3913C8.54659 7.3913 5.3913 10.0026 5.3913 11.5652C5.3913 13.1279 8.54659 15.7391 12 15.7391C15.4534 15.7391 18.6087 13.1279 18.6087 11.5652C18.6087 10.0026 15.4534 7.3913 12 7.3913ZM12 8.78261C13.5368 8.78261 14.7826 10.0284 14.7826 11.5652C14.7826 13.102 13.5368 14.3478 12 14.3478C10.4632 14.3478 9.21739 13.102 9.21739 11.5652C9.21739 10.0284 10.4632 8.78261 12 8.78261ZM12 10.1739C11.2316 10.1739 10.6087 10.7968 10.6087 11.5652C10.6087 12.3336 11.2316 12.9565 12 12.9565C12.7684 12.9565 13.3913 12.3336 13.3913 11.5652C13.3913 10.7968 12.7684 10.1739 12 10.1739Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const EyeOffIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={props.onClick}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M2.99902 3L20.999 21M9.8433 9.91364C9.32066 10.4536 8.99902 11.1892 8.99902 12C8.99902 13.6569 10.3422 15 11.999 15C12.8215 15 13.5667 14.669 14.1086 14.133M6.49902 6.64715C4.59972 7.90034 3.15305 9.78394 2.45703 12C3.73128 16.0571 7.52159 19 11.9992 19C13.9881 19 15.8414 18.4194 17.3988 17.4184M10.999 5.04939C11.328 5.01673 11.6617 5 11.9992 5C16.4769 5 20.2672 7.94291 21.5414 12C21.2607 12.894 20.8577 13.7338 20.3522 14.5"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>{' '}
      </g>
    </svg>
  );
};

export const AddUserIcon = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.375 3C5.13236 3 4.125 4.00736 4.125 5.25C4.125 6.49264 5.13236 7.5 6.375 7.5C7.61764 7.5 8.625 6.49264 8.625 5.25C8.625 4.00736 7.61764 3 6.375 3ZM2.625 5.25C2.625 3.17893 4.30393 1.5 6.375 1.5C8.44607 1.5 10.125 3.17893 10.125 5.25C10.125 7.32107 8.44607 9 6.375 9C4.30393 9 2.625 7.32107 2.625 5.25ZM15 5.25C15.4142 5.25 15.75 5.58579 15.75 6V7.5H17.25C17.6642 7.5 18 7.83579 18 8.25C18 8.66421 17.6642 9 17.25 9H15.75V10.5C15.75 10.9142 15.4142 11.25 15 11.25C14.5858 11.25 14.25 10.9142 14.25 10.5V9H12.75C12.3358 9 12 8.66421 12 8.25C12 7.83579 12.3358 7.5 12.75 7.5H14.25V6C14.25 5.58579 14.5858 5.25 15 5.25ZM1.09835 11.5984C1.80161 10.8951 2.75544 10.5 3.75 10.5H9C9.99456 10.5 10.9484 10.8951 11.6517 11.5984C12.3549 12.3016 12.75 13.2554 12.75 14.25V15.75C12.75 16.1642 12.4142 16.5 12 16.5C11.5858 16.5 11.25 16.1642 11.25 15.75V14.25C11.25 13.6533 11.0129 13.081 10.591 12.659C10.169 12.2371 9.59674 12 9 12H3.75C3.15326 12 2.58097 12.2371 2.15901 12.659C1.73705 13.081 1.5 13.6533 1.5 14.25V15.75C1.5 16.1642 1.16421 16.5 0.75 16.5C0.335786 16.5 0 16.1642 0 15.75V14.25C0 13.2554 0.395088 12.3016 1.09835 11.5984Z"
        fill="#64BBCD"
      />
    </svg>
  );
};

export const ImageIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8332 1.66699H4.1665C3.50346 1.66699 2.86758 1.93038 2.39874 2.39923C1.9299 2.86807 1.6665 3.50395 1.6665 4.16699V15.8337C1.6665 16.4967 1.9299 17.1326 2.39874 17.6014C2.86758 18.0703 3.50346 18.3337 4.1665 18.3337H15.8332C15.9702 18.3317 16.1069 18.3178 16.2415 18.292L16.4915 18.2337H16.5498H16.5915L16.8998 18.117L17.0082 18.0587C17.0915 18.0087 17.1832 17.967 17.2665 17.9087C17.3778 17.8268 17.4836 17.7377 17.5832 17.642L17.6415 17.567C17.7233 17.4841 17.7985 17.3949 17.8665 17.3003L17.9415 17.192C17.9997 17.0992 18.0499 17.0016 18.0915 16.9003C18.1144 16.8603 18.1339 16.8185 18.1498 16.7753C18.1915 16.6753 18.2165 16.567 18.2498 16.4587V16.3337C18.2971 16.1708 18.3251 16.003 18.3332 15.8337V4.16699C18.3332 3.50395 18.0698 2.86807 17.6009 2.39923C17.1321 1.93038 16.4962 1.66699 15.8332 1.66699ZM4.1665 16.667C3.94549 16.667 3.73353 16.5792 3.57725 16.4229C3.42097 16.2666 3.33317 16.0547 3.33317 15.8337V12.242L6.07484 9.49199C6.15231 9.41389 6.24447 9.35189 6.34602 9.30958C6.44757 9.26728 6.55649 9.24549 6.6665 9.24549C6.77651 9.24549 6.88544 9.26728 6.98698 9.30958C7.08853 9.35189 7.1807 9.41389 7.25817 9.49199L14.4248 16.667H4.1665ZM16.6665 15.8337C16.6657 15.9364 16.6459 16.0381 16.6082 16.1337C16.5891 16.1743 16.5668 16.2133 16.5415 16.2503C16.5192 16.2856 16.4941 16.319 16.4665 16.3503L12.0082 11.892L12.7415 11.1587C12.819 11.0806 12.9111 11.0186 13.0127 10.9762C13.1142 10.9339 13.2232 10.9122 13.3332 10.9122C13.4432 10.9122 13.5521 10.9339 13.6537 10.9762C13.7552 11.0186 13.8474 11.0806 13.9248 11.1587L16.6665 13.9087V15.8337ZM16.6665 11.5503L15.0998 10.0003C14.6229 9.54782 13.9906 9.29556 13.3332 9.29556C12.6758 9.29556 12.0434 9.54782 11.5665 10.0003L10.8332 10.7337L8.43317 8.33366C7.95627 7.88115 7.32392 7.62889 6.6665 7.62889C6.00909 7.62889 5.37674 7.88115 4.89984 8.33366L3.33317 9.88366V4.16699C3.33317 3.94598 3.42097 3.73402 3.57725 3.57774C3.73353 3.42146 3.94549 3.33366 4.1665 3.33366H15.8332C16.0542 3.33366 16.2661 3.42146 16.4224 3.57774C16.5787 3.73402 16.6665 3.94598 16.6665 4.16699V11.5503ZM11.2498 5.00033C11.0026 5.00033 10.7609 5.07364 10.5554 5.21099C10.3498 5.34834 10.1896 5.54356 10.095 5.77197C10.0004 6.00038 9.97562 6.25171 10.0239 6.49419C10.0721 6.73666 10.1911 6.95939 10.366 7.13421C10.5408 7.30903 10.7635 7.42808 11.006 7.47631C11.2485 7.52454 11.4998 7.49978 11.7282 7.40518C11.9566 7.31057 12.1518 7.15035 12.2892 6.94479C12.4265 6.73923 12.4998 6.49755 12.4998 6.25033C12.4998 5.91881 12.3681 5.60086 12.1337 5.36644C11.8993 5.13202 11.5814 5.00033 11.2498 5.00033Z"
        fill="#64748B"
      />
    </svg>
  );
};

export const TrashIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="100"
      height="100"
      viewBox="0 0 24 24"
    >
      <path d="M 10 2 L 9 3 L 5 3 C 4.4 3 4 3.4 4 4 C 4 4.6 4.4 5 5 5 L 7 5 L 17 5 L 19 5 C 19.6 5 20 4.6 20 4 C 20 3.4 19.6 3 19 3 L 15 3 L 14 2 L 10 2 z M 5 7 L 5 20 C 5 21.1 5.9 22 7 22 L 17 22 C 18.1 22 19 21.1 19 20 L 19 7 L 5 7 z M 9 9 C 9.6 9 10 9.4 10 10 L 10 19 C 10 19.6 9.6 20 9 20 C 8.4 20 8 19.6 8 19 L 8 10 C 8 9.4 8.4 9 9 9 z M 15 9 C 15.6 9 16 9.4 16 10 L 16 19 C 16 19.6 15.6 20 15 20 C 14.4 20 14 19.6 14 19 L 14 10 C 14 9.4 14.4 9 15 9 z"></path>
    </svg>
  );
};

export const ChevronLeft = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7365 17.7364C15.088 17.3849 15.088 16.8151 14.7365 16.4636L10.2729 12L14.7365 7.5364C15.088 7.18492 15.088 6.61507 14.7365 6.2636C14.385 5.91213 13.8152 5.91213 13.4637 6.26361L8.3637 11.3636C8.01223 11.7151 8.01223 12.285 8.3637 12.6364L13.4637 17.7364C13.8152 18.0879 14.385 18.0879 14.7365 17.7364Z"
        fill="#64BBCD"
      />
    </svg>
  );
};

export const SearchIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.4446 11.2222C6.4446 13.9222 8.63341 16.111 11.3334 16.111C12.5927 16.111 13.7407 15.6349 14.6074 14.8529C14.6399 14.7755 14.6877 14.703 14.7507 14.64C14.8138 14.577 14.8863 14.5292 14.9637 14.4967C15.746 13.6299 16.2223 12.4817 16.2223 11.2222C16.2223 8.52214 14.0335 6.33333 11.3334 6.33333C8.63341 6.33333 6.4446 8.52214 6.4446 11.2222ZM16.1792 15.1257C17.0402 14.0582 17.5556 12.7004 17.5556 11.2222C17.5556 7.78576 14.7699 5 11.3334 5C7.89703 5 5.11127 7.78576 5.11127 11.2222C5.11127 14.6586 7.89703 17.4444 11.3334 17.4444C12.8114 17.4444 14.1689 16.9291 15.2363 16.0684L17.8618 18.6939C18.1222 18.9543 18.5443 18.9543 18.8046 18.6939C19.065 18.4336 19.065 18.0115 18.8046 17.7511L16.1792 15.1257Z"
        fill="#64BBCD"
      />
    </svg>
  );
};

export const CrossIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3333 11.2867C11.2084 11.4109 11.0395 11.4806 10.8633 11.4806C10.6872 11.4806 10.5182 11.4109 10.3933 11.2867L4.70001 5.66006C4.63752 5.59808 4.58792 5.52435 4.55408 5.44311C4.52023 5.36187 4.50281 5.27473 4.50281 5.18673C4.50281 5.09872 4.52023 5.01158 4.55408 4.93034C4.58792 4.8491 4.63752 4.77537 4.70001 4.71339C4.82491 4.58923 4.99388 4.51953 5.17001 4.51953C5.34613 4.51953 5.5151 4.58923 5.64001 4.71339L11.3333 10.3401C11.3958 10.402 11.4454 10.4758 11.4793 10.557C11.5131 10.6382 11.5305 10.7254 11.5305 10.8134C11.5305 10.9014 11.5131 10.9885 11.4793 11.0698C11.4454 11.151 11.3958 11.2248 11.3333 11.2867Z"
        fill="#7E8299"
      />
      <path
        d="M5.63995 11.3334C5.51264 11.4624 5.33928 11.5356 5.15799 11.5369C4.97671 11.5381 4.80235 11.4673 4.67328 11.34C4.54421 11.2127 4.47099 11.0394 4.46974 10.8581C4.46849 10.6768 4.53931 10.5024 4.66661 10.3734L10.3599 4.66669C10.4872 4.53762 10.6606 4.4644 10.8419 4.46315C11.0232 4.4619 11.1975 4.53272 11.3266 4.66002C11.4557 4.78732 11.5289 4.96069 11.5301 5.14197C11.5314 5.32326 11.4606 5.49762 11.3333 5.62669L5.63995 11.3334Z"
        fill="#7E8299"
      />
    </svg>
  );
};

export const ArrowUp = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.21967 12.2803C5.51256 12.5732 5.98744 12.5732 6.28033 12.2803L9.99998 8.56066L13.7197 12.2803C14.0126 12.5732 14.4874 12.5732 14.7803 12.2803C15.0732 11.9874 15.0732 11.5126 14.7803 11.2197L10.5303 6.96967C10.2374 6.67678 9.76254 6.67678 9.46965 6.96967L5.21967 11.2197C4.92678 11.5126 4.92678 11.9874 5.21967 12.2803Z"
        fill="#64BBCD"
      />
    </svg>
  );
};

export const Grid = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      onClick={props.onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.89167 2.57153H6.82283H6.8228C6.25206 2.57152 5.77248 2.57151 5.38003 2.60358C4.96969 2.6371 4.57973 2.70991 4.20956 2.89852C3.64508 3.18614 3.18614 3.64508 2.89852 4.20956C2.70991 4.57973 2.6371 4.96969 2.60358 5.38003C2.57151 5.77248 2.57152 6.25206 2.57153 6.8228V6.82283V6.89167V6.8917C2.57152 7.46243 2.57151 7.94202 2.60358 8.33447C2.6371 8.7448 2.70991 9.13477 2.89852 9.50494C3.18614 10.0694 3.64508 10.5284 4.20956 10.816C4.57973 11.0046 4.96969 11.0774 5.38003 11.1109C5.77249 11.143 6.25209 11.143 6.82285 11.143H6.89165C7.46241 11.143 7.94201 11.143 8.33447 11.1109C8.7448 11.0774 9.13477 11.0046 9.50494 10.816C10.0694 10.5284 10.5284 10.0694 10.816 9.50494C11.0046 9.13477 11.0774 8.7448 11.1109 8.33447C11.143 7.94201 11.143 7.46241 11.143 6.89165V6.82285C11.143 6.25209 11.143 5.77249 11.1109 5.38003C11.0774 4.96969 11.0046 4.57973 10.816 4.20956C10.5284 3.64508 10.0694 3.18614 9.50494 2.89852C9.13477 2.70991 8.7448 2.6371 8.33447 2.60358C7.94202 2.57151 7.46243 2.57152 6.8917 2.57153H6.89167ZM4.98783 4.42595C5.07605 4.38101 5.2153 4.33703 5.51962 4.31217C5.83395 4.28649 6.24305 4.28582 6.85725 4.28582C7.47145 4.28582 7.88055 4.28649 8.19487 4.31217C8.49919 4.33703 8.63845 4.38101 8.72667 4.42595C8.96859 4.54922 9.16528 4.74591 9.28854 4.98783C9.33349 5.07605 9.37747 5.2153 9.40233 5.51962C9.42801 5.83395 9.42868 6.24305 9.42868 6.85725C9.42868 7.47145 9.42801 7.88055 9.40233 8.19487C9.37747 8.49919 9.33349 8.63845 9.28854 8.72667C9.16528 8.96859 8.96859 9.16528 8.72667 9.28854C8.63845 9.33349 8.49919 9.37747 8.19487 9.40233C7.88055 9.42801 7.47145 9.42868 6.85725 9.42868C6.24305 9.42868 5.83395 9.42801 5.51962 9.40233C5.2153 9.37747 5.07605 9.33349 4.98783 9.28854C4.74591 9.16528 4.54922 8.96859 4.42595 8.72667C4.38101 8.63845 4.33703 8.49919 4.31217 8.19487C4.28649 7.88055 4.28582 7.47145 4.28582 6.85725C4.28582 6.24305 4.28649 5.83395 4.31217 5.51962C4.33703 5.2153 4.38101 5.07605 4.42595 4.98783C4.54922 4.74591 4.74591 4.54922 4.98783 4.42595ZM8.33447 12.8893C7.94201 12.8572 7.46242 12.8572 6.89167 12.8572H6.82283C6.25208 12.8572 5.77249 12.8572 5.38003 12.8893C4.96969 12.9228 4.57973 12.9956 4.20956 13.1842C3.64508 13.4718 3.18614 13.9308 2.89852 14.4953C2.70991 14.8654 2.6371 15.2554 2.60358 15.6657C2.57151 16.0582 2.57152 16.5378 2.57153 17.1085V17.1085V17.1774V17.1774C2.57152 17.7481 2.57151 18.2277 2.60358 18.6202C2.6371 19.0305 2.70991 19.4205 2.89852 19.7906C3.18614 20.3551 3.64508 20.8141 4.20956 21.1017C4.57973 21.2903 4.96969 21.3631 5.38003 21.3966C5.77249 21.4287 6.25209 21.4287 6.82285 21.4287H6.89165C7.46241 21.4287 7.94201 21.4287 8.33447 21.3966C8.7448 21.3631 9.13477 21.2903 9.50494 21.1017C10.0694 20.8141 10.5284 20.3551 10.816 19.7906C11.0046 19.4205 11.0774 19.0305 11.1109 18.6202C11.143 18.2277 11.143 17.7481 11.143 17.1774V17.1086C11.143 16.5378 11.143 16.0582 11.1109 15.6657C11.0774 15.2554 11.0046 14.8654 10.816 14.4953C10.5284 13.9308 10.0694 13.4718 9.50494 13.1842C9.13477 12.9956 8.7448 12.9228 8.33447 12.8893ZM4.98783 14.7117C5.07605 14.6667 5.2153 14.6227 5.51962 14.5979C5.83395 14.5722 6.24305 14.5715 6.85725 14.5715C7.47145 14.5715 7.88055 14.5722 8.19487 14.5979C8.49919 14.6227 8.63845 14.6667 8.72667 14.7117C8.96859 14.8349 9.16528 15.0316 9.28854 15.2735C9.33349 15.3618 9.37747 15.501 9.40233 15.8053C9.42801 16.1197 9.42868 16.5288 9.42868 17.143C9.42868 17.7572 9.42801 18.1663 9.40233 18.4806C9.37747 18.7849 9.33349 18.9242 9.28854 19.0124C9.16528 19.2543 8.96859 19.451 8.72667 19.5743C8.63845 19.6192 8.49919 19.6632 8.19487 19.688C7.88055 19.7137 7.47145 19.7144 6.85725 19.7144C6.24305 19.7144 5.83395 19.7137 5.51962 19.688C5.2153 19.6632 5.07605 19.6192 4.98783 19.5743C4.74591 19.451 4.54922 19.2543 4.42595 19.0124C4.38101 18.9242 4.33703 18.7849 4.31217 18.4806C4.28649 18.1663 4.28582 17.7572 4.28582 17.143C4.28582 16.5288 4.28649 16.1197 4.31217 15.8053C4.33703 15.501 4.38101 15.3618 4.42595 15.2735C4.54922 15.0316 4.74591 14.8349 4.98783 14.7117ZM15.6657 12.8893C16.0582 12.8572 16.5378 12.8572 17.1085 12.8572H17.1774C17.7481 12.8572 18.2277 12.8572 18.6202 12.8893C19.0305 12.9228 19.4205 12.9956 19.7906 13.1842C20.3551 13.4718 20.8141 13.9308 21.1017 14.4953C21.2903 14.8654 21.3631 15.2554 21.3966 15.6657C21.4287 16.0582 21.4287 16.5378 21.4287 17.1086V17.1774C21.4287 17.7481 21.4287 18.2277 21.3966 18.6202C21.3631 19.0305 21.2903 19.4205 21.1017 19.7906C20.8141 20.3551 20.3551 20.8141 19.7906 21.1017C19.4205 21.2903 19.0305 21.3631 18.6202 21.3966C18.2277 21.4287 17.7481 21.4287 17.1774 21.4287H17.1086C16.5378 21.4287 16.0582 21.4287 15.6657 21.3966C15.2554 21.3631 14.8654 21.2903 14.4953 21.1017C13.9308 20.8141 13.4718 20.3551 13.1842 19.7906C12.9956 19.4205 12.9228 19.0305 12.8893 18.6202C12.8572 18.2277 12.8572 17.7481 12.8572 17.1774V17.1085C12.8572 16.5378 12.8572 16.0582 12.8893 15.6657C12.9228 15.2554 12.9956 14.8654 13.1842 14.4953C13.4718 13.9308 13.9308 13.4718 14.4953 13.1842C14.8654 12.9956 15.2554 12.9228 15.6657 12.8893ZM15.8053 14.5979C15.501 14.6227 15.3618 14.6667 15.2735 14.7117C15.0316 14.8349 14.8349 15.0316 14.7117 15.2735C14.6667 15.3618 14.6227 15.501 14.5979 15.8053C14.5722 16.1197 14.5715 16.5288 14.5715 17.143C14.5715 17.7572 14.5722 18.1663 14.5979 18.4806C14.6227 18.7849 14.6667 18.9242 14.7117 19.0124C14.8349 19.2543 15.0316 19.451 15.2735 19.5743C15.3618 19.6192 15.501 19.6632 15.8053 19.688C16.1197 19.7137 16.5288 19.7144 17.143 19.7144C17.7572 19.7144 18.1663 19.7137 18.4806 19.688C18.7849 19.6632 18.9242 19.6192 19.0124 19.5743C19.2543 19.451 19.451 19.2543 19.5743 19.0124C19.6192 18.9242 19.6632 18.7849 19.688 18.4806C19.7137 18.1663 19.7144 17.7572 19.7144 17.143C19.7144 16.5288 19.7137 16.1197 19.688 15.8053C19.6632 15.501 19.6192 15.3618 19.5743 15.2735C19.451 15.0316 19.2543 14.8349 19.0124 14.7117C18.9242 14.6667 18.7849 14.6227 18.4806 14.5979C18.1663 14.5722 17.7572 14.5715 17.143 14.5715C16.5288 14.5715 16.1197 14.5722 15.8053 14.5979ZM17.1774 2.57153H17.1085H17.1085C16.5378 2.57152 16.0582 2.57151 15.6657 2.60358C15.2554 2.6371 14.8654 2.70991 14.4953 2.89852C13.9308 3.18614 13.4718 3.64508 13.1842 4.20956C12.9956 4.57973 12.9228 4.96969 12.8893 5.38003C12.8572 5.77249 12.8572 6.25208 12.8572 6.82283V6.89167C12.8572 7.46242 12.8572 7.94201 12.8893 8.33447C12.9228 8.7448 12.9956 9.13477 13.1842 9.50494C13.4718 10.0694 13.9308 10.5284 14.4953 10.816C14.8654 11.0046 15.2554 11.0774 15.6657 11.1109C16.0582 11.143 16.5378 11.143 17.1086 11.143H17.1774C17.7481 11.143 18.2277 11.143 18.6202 11.1109C19.0305 11.0774 19.4205 11.0046 19.7906 10.816C20.3551 10.5284 20.8141 10.0694 21.1017 9.50494C21.2903 9.13477 21.3631 8.7448 21.3966 8.33447C21.4287 7.94201 21.4287 7.46241 21.4287 6.89165V6.82285C21.4287 6.25209 21.4287 5.77249 21.3966 5.38003C21.3631 4.96969 21.2903 4.57973 21.1017 4.20956C20.8141 3.64508 20.3551 3.18614 19.7906 2.89852C19.4205 2.70991 19.0305 2.6371 18.6202 2.60358C18.2277 2.57151 17.7481 2.57152 17.1774 2.57153H17.1774ZM15.2735 4.42595C15.3618 4.38101 15.501 4.33703 15.8053 4.31217C16.1197 4.28649 16.5288 4.28582 17.143 4.28582C17.7572 4.28582 18.1663 4.28649 18.4806 4.31217C18.7849 4.33703 18.9242 4.38101 19.0124 4.42595C19.2543 4.54922 19.451 4.74591 19.5743 4.98783C19.6192 5.07605 19.6632 5.2153 19.688 5.51962C19.7137 5.83395 19.7144 6.24305 19.7144 6.85725C19.7144 7.47145 19.7137 7.88055 19.688 8.19487C19.6632 8.49919 19.6192 8.63845 19.5743 8.72667C19.451 8.96859 19.2543 9.16528 19.0124 9.28854C18.9242 9.33349 18.7849 9.37747 18.4806 9.40233C18.1663 9.42801 17.7572 9.42868 17.143 9.42868C16.5288 9.42868 16.1197 9.42801 15.8053 9.40233C15.501 9.37747 15.3618 9.33349 15.2735 9.28854C15.0316 9.16528 14.8349 8.96859 14.7117 8.72667C14.6667 8.63845 14.6227 8.49919 14.5979 8.19487C14.5722 7.88055 14.5715 7.47145 14.5715 6.85725C14.5715 6.24305 14.5722 5.83395 14.5979 5.51962C14.6227 5.2153 14.6667 5.07605 14.7117 4.98783C14.8349 4.74591 15.0316 4.54922 15.2735 4.42595Z"
        fill="#64BBCD"
      />
    </svg>
  );
};

export const List = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      onClick={props.onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.89167 2.57153H6.82283C6.25209 2.57152 5.77248 2.57151 5.38003 2.60358C4.96969 2.6371 4.57973 2.70991 4.20956 2.89852C3.64508 3.18614 3.18614 3.64508 2.89852 4.20956C2.70991 4.57973 2.6371 4.96969 2.60358 5.38003C2.57151 5.77248 2.57152 6.25206 2.57153 6.8228V6.89167C2.57152 7.4624 2.57151 7.94202 2.60358 8.33447C2.6371 8.7448 2.70991 9.13477 2.89852 9.50494C3.18614 10.0694 3.64508 10.5284 4.20956 10.816C4.57973 11.0046 4.96969 11.0774 5.38003 11.1109C5.77249 11.143 6.25209 11.143 6.82285 11.143H6.89165C7.46241 11.143 18.2277 11.143 18.6202 11.1109C19.0305 11.0774 19.4205 11.0046 19.7906 10.816C20.3551 10.5284 20.8141 10.0694 21.1017 9.50494C21.2903 9.13477 21.3631 8.7448 21.3966 8.33447C21.4287 7.94201 21.4287 7.46242 21.4287 6.89167V6.82285C21.4287 6.2521 21.4287 5.77249 21.3966 5.38003C21.3631 4.96969 21.2903 4.57973 21.1017 4.20956C20.8141 3.64508 20.3551 3.18614 19.7906 2.89852C19.4205 2.70991 19.0305 2.6371 18.6202 2.60358C18.2277 2.57151 7.46242 2.57152 6.89167 2.57153ZM4.98783 4.42595C5.07605 4.381 5.2153 4.33703 5.51962 4.31217C5.83395 4.28649 6.24305 4.28582 6.85725 4.28582C7.47145 4.28582 18.1663 4.28649 18.4806 4.31217C18.7849 4.33703 18.9242 4.381 19.0124 4.42595C19.2543 4.54922 19.451 4.74591 19.5743 4.98783C19.6192 5.07605 19.6632 5.2153 19.688 5.51962C19.7137 5.83395 19.7144 6.24305 19.7144 6.85725C19.7144 7.47145 19.7137 7.88055 19.688 8.19487C19.6632 8.49919 19.6192 8.63845 19.5743 8.72667C19.451 8.96859 19.2543 9.16528 19.0124 9.28854C18.9242 9.33349 18.7849 9.37747 18.4806 9.40233C18.1663 9.42801 7.47145 9.42868 6.85725 9.42868C6.24305 9.42868 5.83395 9.42801 5.51962 9.40233C5.2153 9.37747 5.07605 9.33349 4.98783 9.28854C4.74591 9.16528 4.54922 8.96859 4.42595 8.72667C4.381 8.63845 4.33703 8.49919 4.31217 8.19487C4.28649 7.88055 4.28582 7.47145 4.28582 6.85725C4.28582 6.24305 4.28649 5.83395 4.31217 5.51962C4.33703 5.2153 4.381 5.07605 4.42595 4.98783C4.54922 4.74591 4.74591 4.54922 4.98783 4.42595Z"
        fill="#64748B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6202 12.8893C18.2277 12.8572 7.46242 12.8572 6.89167 12.8572H6.82283C6.25208 12.8572 5.77249 12.8572 5.38003 12.8893C4.96969 12.9228 4.57973 12.9956 4.20956 13.1842C3.64508 13.4719 3.18614 13.9308 2.89852 14.4953C2.70991 14.8654 2.6371 15.2554 2.60358 15.6657C2.57151 16.0582 2.57152 16.5378 2.57153 17.1085V17.1774C2.57152 17.7481 2.57151 18.2277 2.60358 18.6202C2.6371 19.0305 2.70991 19.4205 2.89852 19.7906C3.18614 20.3551 3.64508 20.8141 4.20956 21.1017C4.57973 21.2903 4.96969 21.3631 5.38003 21.3966C5.77249 21.4287 6.25208 21.4287 6.82282 21.4287H6.89165C7.46241 21.4287 18.2277 21.4287 18.6202 21.3966C19.0305 21.3631 19.4205 21.2903 19.7906 21.1017C20.3551 20.8141 20.8141 20.3551 21.1017 19.7906C21.2903 19.4205 21.3631 19.0305 21.3966 18.6202C21.4287 18.2277 21.4287 17.7481 21.4287 17.1774V17.1086C21.4287 16.5378 21.4287 16.0582 21.3966 15.6657C21.3631 15.2554 21.2903 14.8654 21.1017 14.4953C20.8141 13.9308 20.3551 13.4719 19.7906 13.1842C19.4205 12.9956 19.0305 12.9228 18.6202 12.8893ZM4.98783 14.7117C5.07605 14.6667 5.2153 14.6227 5.51962 14.5979C5.83395 14.5722 6.24305 14.5715 6.85725 14.5715C7.47145 14.5715 18.1663 14.5722 18.4806 14.5979C18.7849 14.6227 18.9242 14.6667 19.0124 14.7117C19.2543 14.8349 19.451 15.0316 19.5743 15.2735C19.6192 15.3618 19.6632 15.501 19.688 15.8053C19.7137 16.1197 19.7144 16.5288 19.7144 17.143C19.7144 17.7572 19.7137 18.1663 19.688 18.4806C19.6632 18.7849 19.6192 18.9242 19.5743 19.0124C19.451 19.2543 19.2543 19.451 19.0124 19.5743C18.9242 19.6192 18.7849 19.6632 18.4806 19.688C18.1663 19.7137 7.47145 19.7144 6.85725 19.7144C6.24305 19.7144 5.83395 19.7137 5.51962 19.688C5.2153 19.6632 5.07605 19.6192 4.98783 19.5743C4.74591 19.451 4.54922 19.2543 4.42595 19.0124C4.381 18.9242 4.33703 18.7849 4.31217 18.4806C4.28649 18.1663 4.28582 17.7572 4.28582 17.143C4.28582 16.5288 4.28649 16.1197 4.31217 15.8053C4.33703 15.501 4.381 15.3618 4.42595 15.2735C4.54922 15.0316 4.74591 14.8349 4.98783 14.7117Z"
        fill="#64748B"
      />
    </svg>
  );
};

export const MaterialIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.43554 2.14282L12.8041 2.14404C14.2028 2.15882 14.9146 2.30955 15.6527 2.70426C16.3592 3.0821 16.9179 3.64083 17.2957 4.34731C17.7124 5.12638 17.8572 5.87618 17.8572 7.43547L17.8559 12.8041C17.8412 14.2028 17.6904 14.9146 17.2957 15.6526C16.9179 16.3591 16.3592 16.9178 15.6527 17.2957C14.8736 17.7123 14.1238 17.8571 12.5645 17.8571L7.19594 17.8559C5.79724 17.8411 5.08543 17.6904 4.34737 17.2957C3.64089 16.9178 3.08216 16.3591 2.70433 15.6526C2.28768 14.8736 2.14288 14.1237 2.14288 12.5645L2.14411 7.19588C2.15888 5.79718 2.30961 5.08537 2.70433 4.34731C3.08216 3.64083 3.64089 3.0821 4.34737 2.70426C5.12644 2.28762 5.87625 2.14282 7.43554 2.14282ZM12.5645 3.57139H7.43554C6.09191 3.57139 5.5649 3.67316 5.02109 3.964C4.56355 4.20869 4.20875 4.56349 3.96406 5.02103C3.70384 5.50759 3.59498 5.98071 3.57494 7.03734L3.57145 7.43547V12.5645C3.57145 13.9081 3.67323 14.4351 3.96406 14.9789C4.20875 15.4364 4.56355 15.7912 5.02109 16.0359C5.50765 16.2962 5.98077 16.405 7.03741 16.4251L7.43554 16.4285H12.5645C13.9081 16.4285 14.4352 16.3268 14.979 16.0359C15.4365 15.7912 15.7913 15.4364 16.036 14.9789C16.2962 14.4923 16.4051 14.0192 16.4251 12.9626L16.4286 12.5645V7.43547C16.4286 6.09185 16.3268 5.56484 16.036 5.02103C15.7913 4.56349 15.4365 4.20869 14.979 3.964C14.4924 3.70378 14.0193 3.59491 12.9626 3.57488L12.5645 3.57139ZM8.57146 12.5C8.96594 12.5 9.28574 12.8198 9.28574 13.2143C9.28574 13.5806 9.01 13.8825 8.65476 13.9237L8.57146 13.9285H6.4286C6.03411 13.9285 5.71431 13.6087 5.71431 13.2143C5.71431 12.8479 5.99006 12.546 6.3453 12.5048L6.4286 12.5H8.57146ZM13.5715 12.5C13.9659 12.5 14.2857 12.8198 14.2857 13.2143C14.2857 13.5806 14.01 13.8825 13.6548 13.9237L13.5715 13.9285H11.4286C11.0341 13.9285 10.7143 13.6087 10.7143 13.2143C10.7143 12.8479 10.9901 12.546 11.3453 12.5048L11.4286 12.5H13.5715ZM8.57146 9.28568C8.96594 9.28568 9.28574 9.60548 9.28574 9.99997C9.28574 10.3663 9.01 10.6682 8.65476 10.7094L8.57146 10.7143H6.4286C6.03411 10.7143 5.71431 10.3945 5.71431 9.99997C5.71431 9.63365 5.99006 9.33175 6.3453 9.29049L6.4286 9.28568H8.57146ZM13.5715 9.28568C13.9659 9.28568 14.2857 9.60548 14.2857 9.99997C14.2857 10.3663 14.01 10.6682 13.6548 10.7094L13.5715 10.7143H11.4286C11.0341 10.7143 10.7143 10.3945 10.7143 9.99997C10.7143 9.63365 10.9901 9.33175 11.3453 9.29049L11.4286 9.28568H13.5715ZM13.5715 6.07139C13.9659 6.07139 14.2857 6.39119 14.2857 6.78568C14.2857 7.15199 14.01 7.4539 13.6548 7.49516L13.5715 7.49997H11.4286C11.0341 7.49997 10.7143 7.18017 10.7143 6.78568C10.7143 6.41937 10.9901 6.11746 11.3453 6.0762L11.4286 6.07139H13.5715ZM8.57146 6.07139C8.96594 6.07139 9.28574 6.39119 9.28574 6.78568C9.28574 7.15199 9.01 7.4539 8.65476 7.49516L8.57146 7.49997H6.4286C6.03411 7.49997 5.71431 7.18017 5.71431 6.78568C5.71431 6.41937 5.99006 6.11746 6.3453 6.0762L6.4286 6.07139H8.57146Z"
        fill="#64BBCD"
      />
    </svg>
  );
};

export const VideoIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.17379 4.14536L14.2168 2.1189C14.5704 2.04716 14.8755 1.98527 15.1586 2.00309C15.9187 2.05095 16.5956 2.50098 16.9343 3.18366C17.0943 3.50632 17.1471 3.87238 17.2178 4.22233C17.2512 4.38592 17.2923 4.58645 17.2802 4.77804C17.2484 5.28515 16.9485 5.73672 16.4937 5.96264C16.3112 6.05332 16.1087 6.09018 15.9105 6.12976L8.18037 7.68948H16.1524L16.175 7.68948C16.3544 7.68946 16.5291 7.68944 16.677 7.70153C16.8394 7.71481 17.0311 7.74615 17.224 7.8445C17.4914 7.98085 17.7088 8.19842 17.8451 8.46603C17.9434 8.65904 17.9747 8.85085 17.988 9.01341C18 9.1614 18 9.33614 18 9.51557L18 9.53837V14.2317V14.2611C18 14.8335 18 15.3059 17.9686 15.6908C17.936 16.0905 17.8659 16.4579 17.6902 16.8031C17.4177 17.3383 16.9828 17.7734 16.448 18.0461C16.1031 18.222 15.7359 18.2921 15.3364 18.3247C14.9518 18.3562 14.4797 18.3562 13.9077 18.3561H13.8783H6.4878H6.45847C5.88643 18.3562 5.41431 18.3562 5.02972 18.3247C4.63027 18.2921 4.26309 18.222 3.9182 18.0461C3.38334 17.7734 2.94849 17.3383 2.67597 16.8031C2.50024 16.4579 2.4302 16.0905 2.39756 15.6908C2.36614 15.3059 2.36615 14.8335 2.36615 14.2611L2.36615 14.2317L2.36615 9.51569C2.36613 9.33622 2.36611 9.16143 2.3782 9.01341C2.39147 8.85085 2.42278 8.65904 2.52106 8.46603C2.55948 8.39058 2.60435 8.31911 2.65497 8.25231C2.51 8.12922 2.38892 7.97637 2.30159 7.80032C2.1991 7.59373 2.16411 7.36269 2.11882 7.13875C2.04713 6.7849 1.98528 6.47962 2.00309 6.19636C2.05092 5.4357 2.50064 4.75835 3.18286 4.41946C3.49089 4.26645 3.83962 4.21255 4.17379 4.14536ZM4.45472 5.53953C3.97798 5.63572 3.87748 5.66223 3.8148 5.69336C3.5874 5.80632 3.43749 6.03211 3.42155 6.28566C3.41715 6.35554 3.43168 6.45853 3.5278 6.93559C3.55085 7.04995 3.56361 7.11244 3.57487 7.15756L3.57671 7.16481L3.5841 7.1637C3.63003 7.15659 3.69254 7.14416 3.80683 7.1211L15.6296 4.73559C15.7439 4.71254 15.8063 4.69976 15.8514 4.6885L15.8587 4.68666L15.8575 4.67926C15.8504 4.6333 15.838 4.57074 15.815 4.45638C15.7188 3.97933 15.6923 3.87875 15.6612 3.81603C15.5483 3.58847 15.3227 3.43846 15.0693 3.42251C14.9995 3.41811 14.8966 3.43265 14.4199 3.52884L4.45472 5.53953ZM3.79555 9.11984L3.79473 9.12922C3.78797 9.21213 3.78741 9.32751 3.78741 9.53837V14.2317C3.78741 14.8408 3.78797 15.2549 3.8141 15.575C3.83955 15.8867 3.88569 16.0462 3.94232 16.1574C4.07858 16.425 4.29601 16.6426 4.56343 16.7789C4.67458 16.8356 4.8339 16.8818 5.14545 16.9072C5.4653 16.9334 5.87909 16.9339 6.4878 16.9339H13.8783C14.4871 16.9339 14.9009 16.9334 15.2207 16.9072C15.5322 16.8818 15.6916 16.8356 15.8027 16.7789C16.0701 16.6426 16.2876 16.425 16.4238 16.1574C16.4805 16.0462 16.5266 15.8867 16.5521 15.575C16.5782 15.2549 16.5787 14.8408 16.5787 14.2317V9.53837C16.5787 9.32751 16.5782 9.21213 16.5714 9.12922L16.5706 9.11984L16.5612 9.11903C16.4784 9.11226 16.3631 9.1117 16.1524 9.1117H4.21379C4.00307 9.1117 3.88777 9.11226 3.80492 9.11903L3.79555 9.11984ZM9.30451 10.9467C9.24742 10.9098 9.18063 10.8902 9.11236 10.8902C8.91879 10.8902 8.76186 11.0448 8.76186 11.2355V14.8115C8.76186 14.8756 8.77995 14.9384 8.8141 14.9929C8.91577 15.1551 9.13173 15.2055 9.29646 15.1053L12.1486 13.3711C12.1922 13.3445 12.2295 13.3088 12.2576 13.2665C12.3637 13.107 12.3185 12.893 12.1566 12.7885L9.30451 10.9467Z"
        fill="#64748B"
      />
    </svg>
  );
};

export const LinkIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2411 3.57757C12.6737 2.14504 14.9963 2.14504 16.4288 3.57757C17.8613 5.0101 17.8613 7.33268 16.4288 8.76521L15.5358 9.65815C15.2428 9.95117 14.7677 9.95117 14.4747 9.65815C14.1817 9.36513 14.1817 8.89006 14.4747 8.59704L15.3677 7.7041C16.2142 6.85761 16.2142 5.48517 15.3677 4.63868C14.5212 3.79218 13.1487 3.79218 12.3022 4.63868L9.35472 7.5862C8.50823 8.43269 8.50823 9.80513 9.35472 10.6516C9.64774 10.9446 9.64774 11.4197 9.35472 11.7127C9.06171 12.0058 8.58663 12.0058 8.29361 11.7127C6.86108 10.2802 6.86108 7.95762 8.29361 6.52509L11.2411 3.57757ZM10.6516 8.29361C10.9446 8.0006 11.4197 8.0006 11.7127 8.29361C13.1453 9.72614 13.1453 12.0487 11.7127 13.4813L8.76521 16.4288C7.33269 17.8613 5.0101 17.8613 3.57757 16.4288C2.14504 14.9963 2.14504 12.6737 3.57757 11.2411L4.51241 10.3063C4.80542 10.0133 5.2805 10.0133 5.57351 10.3063C5.86653 10.5993 5.86653 11.0744 5.57351 11.3674L4.63868 12.3022C3.79218 13.1487 3.79218 14.5212 4.63868 15.3677C5.48517 16.2142 6.85761 16.2142 7.7041 15.3677L10.6516 12.4201C11.4981 11.5737 11.4981 10.2012 10.6516 9.35472C10.3586 9.0617 10.3586 8.58663 10.6516 8.29361Z"
        fill="white"
      />
    </svg>
  );
};

export const MoreDotIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16ZM12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14ZM12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8Z"
        fill="#64748B"
      />
    </svg>
  );
};

export const PencilIcon = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6945 5.60841L3.91671 12.3863C3.76199 12.541 3.67507 12.7508 3.67507 12.9696L3.67507 14.2499C3.67507 14.2914 3.70865 14.3249 3.75007 14.3249H5.0304C5.2492 14.3249 5.45905 14.238 5.61376 14.0833L12.3916 7.30547L10.6945 5.60841ZM11.6491 4.65382L13.3462 6.35087L14.1947 5.50234C14.3704 5.32661 14.3704 5.04168 14.1947 4.86595L13.1341 3.80529C12.9583 3.62955 12.6734 3.62955 12.4977 3.80529L11.6491 4.65382ZM2.96211 11.4317L11.5431 2.85069C12.246 2.14775 13.3857 2.14775 14.0886 2.85069L15.1493 3.91135C15.8522 4.6143 15.8522 5.754 15.1493 6.45694L6.56836 15.0379C6.16047 15.4458 5.60725 15.6749 5.0304 15.6749L3.75007 15.6749C2.96307 15.6749 2.32507 15.037 2.32507 14.2499L2.32507 12.9696C2.32507 12.3928 2.55422 11.8396 2.96211 11.4317Z"
        fill="#64748B"
      />
    </svg>
  );
};

export const CheckMarkIcon = (props) => {
  return (
    <svg
      width="64px"
      height="64px"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M866.133333 258.133333L362.666667 761.6l-204.8-204.8L98.133333 618.666667 362.666667 881.066667l563.2-563.2z"
          fill="#43A047"
        ></path>
      </g>
    </svg>
  );
};

export const UploadIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L12 13.4142L8.70711 16.7071C8.31658 17.0976 7.68342 17.0976 7.29289 16.7071C6.90237 16.3166 6.90237 15.6834 7.29289 15.2929L11.2929 11.2929C11.6834 10.9024 12.3166 10.9024 12.7071 11.2929L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071Z"
        fill="#368F9B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21C11.4477 21 11 20.5523 11 20L11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12L13 20C13 20.5523 12.5523 21 12 21Z"
        fill="#368F9B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.97059 3.00546C10.2238 2.95948 11.4703 3.20425 12.616 3.72056C13.7616 4.23684 14.7756 5.01074 15.5827 5.98252C16.2219 6.75205 16.7183 7.62992 17.0508 8.57311L17.4529 8.57311C18.6357 8.57234 19.7868 8.95622 20.7376 9.66594C21.6883 10.3756 22.3893 11.3732 22.7429 12.5118C23.0963 13.6502 23.0851 14.8734 22.7108 16.0049C22.3364 17.1367 21.617 18.121 20.6533 18.8125C20.2045 19.1345 19.5798 19.0317 19.2578 18.583C18.9358 18.1342 19.0386 17.5095 19.4873 17.1875C20.1034 16.7455 20.5687 16.1121 20.812 15.3768C21.0553 14.6412 21.0627 13.8451 20.8328 13.1049C20.603 12.3649 20.1493 11.7225 19.5412 11.2687C18.9335 10.815 18.2026 10.5725 17.4544 10.5731L16.3089 10.5731C15.8505 10.5731 15.4508 10.2615 15.3391 9.81699C15.102 8.87432 14.6588 8.00033 14.0442 7.26039C13.4297 6.52052 12.6601 5.93415 11.7942 5.54395C10.9285 5.15378 9.98819 4.96947 9.04392 5.00412C8.09965 5.03877 7.17448 5.29153 6.33793 5.74441C5.50129 6.19734 4.77443 6.83902 4.21319 7.62256C3.65191 8.40617 3.27123 9.31087 3.10109 10.2688C2.93095 11.2267 2.97605 12.2115 3.2328 13.1488C3.48955 14.0859 3.9509 14.9499 4.58072 15.6761C4.94258 16.0933 4.89769 16.7249 4.48046 17.0868C4.06323 17.4486 3.43166 17.4037 3.0698 16.9865C2.24241 16.0325 1.63909 14.9008 1.30388 13.6772C0.96867 12.4536 0.909935 11.1688 1.13191 9.919C1.35389 8.6692 1.85106 7.48574 2.58726 6.45793C3.32352 5.43005 4.27998 4.58425 5.38577 3.98561C6.49165 3.38692 7.71739 3.05145 8.97059 3.00546Z"
        fill="#368F9B"
      />
    </svg>
  );
};

export const GlobeIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0018 4L12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58233 16.4193 4.00099 12.0018 4ZM13.5425 18.4873C15.3484 18.0595 16.8701 16.8972 17.7748 15.3333H14.9191C14.6519 16.3524 14.2864 17.1943 13.9171 17.8637C13.7912 18.0918 13.6651 18.2996 13.5425 18.4873ZM15.1902 14H18.3615C18.5598 13.3686 18.6667 12.6968 18.6667 12C18.6667 11.3032 18.5598 10.6314 18.3615 10H15.1902C15.281 10.6163 15.3333 11.2827 15.3333 12C15.3333 12.7173 15.281 13.3837 15.1902 14ZM13.8408 10C13.9407 10.6065 14 11.2727 14 12C14 12.7273 13.9407 13.3935 13.8408 14H10.1592C10.0593 13.3935 10 12.7273 10 12C10 11.2727 10.0593 10.6065 10.1592 10H13.8408ZM14.9191 8.66667H17.7748C16.8701 7.10276 15.3484 5.94046 13.5425 5.51268C13.6651 5.70043 13.7912 5.90821 13.9171 6.13628C14.2864 6.80573 14.6519 7.64763 14.9191 8.66667ZM10.4575 5.51268C8.65161 5.94046 7.12989 7.10276 6.22521 8.66667H9.08087C9.34806 7.64763 9.7136 6.80573 10.0829 6.13628C10.2088 5.90821 10.3349 5.70043 10.4575 5.51268ZM10.4654 8.66667C10.6905 7.91241 10.9719 7.28516 11.2504 6.78039C11.5194 6.29279 11.7867 5.91777 12 5.65224C12.2133 5.91777 12.4806 6.29279 12.7496 6.78039C13.0281 7.28516 13.3095 7.91241 13.5346 8.66667H10.4654ZM8.80979 10H5.63853C5.44024 10.6314 5.33333 11.3032 5.33333 12C5.33333 12.6968 5.44024 13.3686 5.63853 14H8.80979C8.71905 13.3837 8.66667 12.7173 8.66667 12C8.66667 11.2827 8.71905 10.6163 8.80979 10ZM9.08087 15.3333H6.22521C7.12989 16.8972 8.65161 18.0595 10.4575 18.4873C10.3349 18.2996 10.2088 18.0918 10.0829 17.8637C9.7136 17.1943 9.34806 16.3524 9.08087 15.3333ZM10.4654 15.3333H13.5346C13.3095 16.0876 13.0281 16.7148 12.7496 17.2196C12.4806 17.7072 12.2133 18.0822 12 18.3478C11.7867 18.0822 11.5194 17.7072 11.2504 17.2196C10.9719 16.7148 10.6905 16.0876 10.4654 15.3333Z"
        fill="#64748B"
      />
    </svg>
  );
};

export const StorageIcon = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4963 16.5426C20.365 19.0476 16.7808 20.8 12.5 20.8C8.13841 20.8 4.5 18.9808 4.5 16.4V8.4L4.50372 8.25741C4.635 5.75245 8.21918 4 12.5 4C16.8616 4 20.5 5.81921 20.5 8.4V16.4L20.4963 16.5426ZM18.9009 11.0924C17.4317 12.1567 15.0937 12.8 12.5 12.8C9.90675 12.8 7.56915 12.1569 6.09994 11.093L6.1 12.4C6.1 13.7957 8.90869 15.2 12.5 15.2C16.0913 15.2 18.9 13.7957 18.9 12.4L18.9009 11.0924ZM12.5 5.6C8.90869 5.6 6.1 7.00434 6.1 8.4C6.1 9.79566 8.90869 11.2 12.5 11.2C16.0913 11.2 18.9 9.79566 18.9 8.4C18.9 7.00434 16.0913 5.6 12.5 5.6ZM18.9009 15.0924C17.4317 16.1567 15.0937 16.8 12.5 16.8C9.90675 16.8 7.56915 16.1569 6.09994 15.093L6.1 16.4L6.10414 16.493C6.22522 17.8574 8.9885 19.2 12.5 19.2C16.0913 19.2 18.9 17.7957 18.9 16.4L18.9009 15.0924Z"
        fill="#64748B"
      />
    </svg>
  );
};


export const LargeTitle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13.5789 20.8421H11.4737V13.4737H4.10526V20.8421H2V4H4.10526V11.3684H11.4737V4H13.5789V20.8421ZM22 8.21053V20.8421H19.8947V10.5305L17.7895 11.0947V8.91579L20.4211 8.21053H22Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SmallTitle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
    >
      <path
        d="M1.97531 0V6.91358H8.88889V0H10.8642V15.8025H8.88889V8.88889H1.97531V15.8025H0V0H1.97531ZM16.2963 3.95062C18.3417 3.95062 20 5.60889 20 7.65432C20 8.50074 19.7156 9.28197 19.2375 9.90617L19.0914 10.084L15.8361 13.8272H19.7531V15.8025H12.8395V14.2657L17.6 8.78815C17.8647 8.48494 18.0247 8.0879 18.0247 7.65432C18.0247 6.70025 17.2504 5.92593 16.2963 5.92593C15.3896 5.92593 14.6459 6.6242 14.5738 7.5121L14.5679 7.65432H12.5926C12.5926 5.60889 14.2509 3.95062 16.2963 3.95062Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Body = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M2.5 3.33337H17.5V5.00004H2.5V3.33337ZM2.5 9.16671H12.5V10.8334H2.5V9.16671ZM2.5 15H17.5V16.6667H2.5V15Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Quotes = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M3.81917 14.4342C2.96083 13.5225 2.5 12.5 2.5 10.8425C2.5 7.92583 4.5475 5.31167 7.525 4.01917L8.26917 5.1675C5.49 6.67083 4.94667 8.62167 4.73 9.85167C5.1775 9.62 5.76333 9.53917 6.3375 9.5925C7.84083 9.73167 9.02583 10.9658 9.02583 12.5C9.02583 13.2735 8.71854 14.0154 8.17156 14.5624C7.62458 15.1094 6.88271 15.4167 6.10917 15.4167C5.215 15.4167 4.36 15.0083 3.81917 14.4342ZM12.1525 14.4342C11.2942 13.5225 10.8333 12.5 10.8333 10.8425C10.8333 7.92583 12.8808 5.31167 15.8583 4.01917L16.6025 5.1675C13.8233 6.67083 13.28 8.62167 13.0633 9.85167C13.5108 9.62 14.0967 9.53917 14.6708 9.5925C16.1742 9.73167 17.3592 10.9658 17.3592 12.5C17.3592 13.2735 17.0519 14.0154 16.5049 14.5624C15.9579 15.1094 15.216 15.4167 14.4425 15.4167C13.5483 15.4167 12.6933 15.0083 12.1525 14.4342Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const LongTextField = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M14.1667 15H2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 11.6666H2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1667 8.33337H2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 5H2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const InputField = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_452_48448)">
        <path
          d="M1.66602 15.8333V4.16663H18.3327V15.8333H1.66602Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path d="M5 5.83337V14.1667" stroke="currentColor" strokeWidth="1.5" />
      </g>
      <defs>
        <clippath id="clip0_452_48448">
          <rect width="20" height="20" fill="white" />
        </clippath>
      </defs>
    </svg>
  );
};

export const Attachment = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M12.3571 6.46415L7.64373 11.1783C7.56414 11.2552 7.50066 11.3471 7.45698 11.4488C7.41331 11.5505 7.39032 11.6598 7.38936 11.7705C7.3884 11.8811 7.40948 11.9909 7.45138 12.0933C7.49328 12.1957 7.55516 12.2887 7.63341 12.367C7.71165 12.4452 7.80469 12.5071 7.90711 12.549C8.00952 12.5909 8.11925 12.612 8.2299 12.611C8.34055 12.6101 8.4499 12.5871 8.55157 12.5434C8.65324 12.4997 8.7452 12.4362 8.82207 12.3567L13.5362 7.64332C14.0051 7.17444 14.2685 6.5385 14.2685 5.8754C14.2685 5.21231 14.0051 4.57637 13.5362 4.10749C13.0674 3.63861 12.4314 3.37519 11.7683 3.37519C11.1052 3.37519 10.4693 3.63861 10.0004 4.10749L5.28624 8.82165C4.8913 9.20676 4.57676 9.66645 4.36087 10.1741C4.14497 10.6817 4.03202 11.2271 4.02857 11.7787C4.02511 12.3303 4.13122 12.8771 4.34073 13.3874C4.55025 13.8977 4.859 14.3613 5.24908 14.7513C5.63916 15.1413 6.1028 15.45 6.61311 15.6595C7.12342 15.8689 7.67024 15.9749 8.22185 15.9714C8.77345 15.9679 9.31887 15.8548 9.82645 15.6389C10.334 15.4229 10.7937 15.1083 11.1787 14.7133L15.8929 9.99999L17.0712 11.1783L12.3571 15.8925C11.8154 16.4342 11.1723 16.8639 10.4645 17.1571C9.75673 17.4502 8.99815 17.6011 8.23207 17.6011C7.46599 17.6011 6.7074 17.4502 5.99963 17.1571C5.29187 16.8639 4.64877 16.4342 4.10707 15.8925C3.56537 15.3508 3.13566 14.7077 2.8425 13.9999C2.54933 13.2922 2.39844 12.5336 2.39844 11.7675C2.39844 11.0014 2.54933 10.2428 2.8425 9.53505C3.13566 8.82729 3.56537 8.18419 4.10707 7.64249L8.82207 2.92915C9.60791 2.17016 10.6604 1.75019 11.7529 1.75968C12.8454 1.76917 13.8904 2.20738 14.663 2.97991C15.4355 3.75244 15.8737 4.7975 15.8832 5.88998C15.8927 6.98247 15.4727 8.03498 14.7137 8.82082L10.0004 13.5367C9.76818 13.7688 9.49251 13.953 9.18912 14.0786C8.88573 14.2042 8.56056 14.2689 8.23219 14.2688C7.90382 14.2688 7.57867 14.2041 7.27531 14.0784C6.97195 13.9527 6.69632 13.7685 6.46415 13.5362C6.23199 13.304 6.04783 13.0283 5.92221 12.725C5.79658 12.4216 5.73194 12.0964 5.73198 11.768C5.73202 11.4397 5.79673 11.1145 5.92243 10.8111C6.04813 10.5078 6.23235 10.2322 6.46457 9.99999L11.1787 5.28582L12.3571 6.46415Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Columns = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.16667 4.16667H4.16667V15.8333H9.16667V4.16667ZM10.8333 4.16667V15.8333H15.8333V4.16667H10.8333ZM3.33333 2.5H16.6667C16.8877 2.5 17.0996 2.5878 17.2559 2.74408C17.4122 2.90036 17.5 3.11232 17.5 3.33333V16.6667C17.5 16.8877 17.4122 17.0996 17.2559 17.2559C17.0996 17.4122 16.8877 17.5 16.6667 17.5H3.33333C3.11232 17.5 2.90036 17.4122 2.74408 17.2559C2.5878 17.0996 2.5 16.8877 2.5 16.6667V3.33333C2.5 3.11232 2.5878 2.90036 2.74408 2.74408C2.90036 2.5878 3.11232 2.5 3.33333 2.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Image = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.16667 9.25L5.83333 7.58333L10.4167 12.1667L13.3333 9.25L15.8333 11.75V4.16667H4.16667V9.25ZM4.16667 11.6075V15.8333H6.75L9.23833 13.3458L5.83333 9.94083L4.16667 11.6075ZM9.1075 15.8333H15.8333V14.1075L13.3333 11.6075L9.1075 15.8333ZM3.33333 2.5H16.6667C16.8877 2.5 17.0996 2.5878 17.2559 2.74408C17.4122 2.90036 17.5 3.11232 17.5 3.33333V16.6667C17.5 16.8877 17.4122 17.0996 17.2559 17.2559C17.0996 17.4122 16.8877 17.5 16.6667 17.5H3.33333C3.11232 17.5 2.90036 17.4122 2.74408 17.2559C2.5878 17.0996 2.5 16.8877 2.5 16.6667V3.33333C2.5 3.11232 2.5878 2.90036 2.74408 2.74408C2.90036 2.5878 3.11232 2.5 3.33333 2.5ZM12.9167 8.33333C12.5851 8.33333 12.2672 8.20164 12.0328 7.96722C11.7984 7.7328 11.6667 7.41485 11.6667 7.08333C11.6667 6.75181 11.7984 6.43387 12.0328 6.19945C12.2672 5.96503 12.5851 5.83333 12.9167 5.83333C13.2482 5.83333 13.5661 5.96503 13.8005 6.19945C14.035 6.43387 14.1667 6.75181 14.1667 7.08333C14.1667 7.41485 14.035 7.7328 13.8005 7.96722C13.5661 8.20164 13.2482 8.33333 12.9167 8.33333Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SmallTitle2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M1.66602 3.3275C1.66754 3.10865 1.7551 2.89918 1.90978 2.74435C2.06445 2.58951 2.27383 2.50175 2.49268 2.5H17.506C17.9627 2.5 18.3327 2.87083 18.3327 3.3275V16.6725C18.3312 16.8914 18.2436 17.1008 18.0889 17.2557C17.9342 17.4105 17.7249 17.4983 17.506 17.5H2.49268C2.27336 17.4998 2.0631 17.4125 1.90809 17.2573C1.75308 17.1022 1.66602 16.8918 1.66602 16.6725V3.3275ZM3.33268 4.16667V15.8333H16.666V4.16667H3.33268ZM8.85102 7.0125L12.9169 9.7225C12.9626 9.75293 13.0001 9.79418 13.026 9.84259C13.0519 9.89101 13.0655 9.94508 13.0655 10C13.0655 10.0549 13.0519 10.109 13.026 10.1574C13.0001 10.2058 12.9626 10.2471 12.9169 10.2775L8.85018 12.9875C8.80004 13.0207 8.74184 13.0398 8.68174 13.0426C8.62165 13.0455 8.56191 13.032 8.50886 13.0036C8.4558 12.9753 8.41141 12.9331 8.3804 12.8815C8.34938 12.83 8.33289 12.771 8.33268 12.7108V7.28917C8.33279 7.22888 8.34926 7.16974 8.38031 7.11807C8.41137 7.06639 8.45587 7.02411 8.50905 6.99572C8.56224 6.96733 8.62214 6.9539 8.68235 6.95685C8.74257 6.95981 8.80086 6.97904 8.85102 7.0125Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Quotes2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.5 3.33329H5.83333C5.39131 3.33329 4.96738 3.50889 4.65482 3.82145C4.34226 4.13401 4.16667 4.55793 4.16667 4.99996C4.16667 5.44199 4.34226 5.86591 4.65482 6.17847C4.96738 6.49103 5.39131 6.66663 5.83333 6.66663H17.5V17.5C17.5 17.721 17.4122 17.9329 17.2559 18.0892C17.0996 18.2455 16.8877 18.3333 16.6667 18.3333H5.83333C4.94928 18.3333 4.10143 17.9821 3.47631 17.357C2.85119 16.7319 2.5 15.884 2.5 15V4.99996C2.5 4.1159 2.85119 3.26806 3.47631 2.64294C4.10143 2.01782 4.94928 1.66663 5.83333 1.66663H16.6667C16.8877 1.66663 17.0996 1.75442 17.2559 1.9107C17.4122 2.06698 17.5 2.27895 17.5 2.49996V3.33329ZM4.16667 15C4.16667 15.442 4.34226 15.8659 4.65482 16.1785C4.96738 16.491 5.39131 16.6666 5.83333 16.6666H15.8333V8.33329H5.83333C5.24819 8.33423 4.6732 8.18042 4.16667 7.88746V15ZM16.6667 5.83329H5.83333C5.61232 5.83329 5.40036 5.7455 5.24408 5.58922C5.0878 5.43293 5 5.22097 5 4.99996C5 4.77895 5.0878 4.56698 5.24408 4.4107C5.40036 4.25442 5.61232 4.16663 5.83333 4.16663H16.6667V5.83329Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const EmbedCode = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M20 10L15.2858 14.7142L14.1075 13.5358L17.6433 10L14.1075 6.46417L15.2858 5.28583L20 10ZM2.35667 10L5.8925 13.5358L4.71417 14.7142L0 10L4.71417 5.28583L5.89167 6.46417L2.35667 10ZM8.15667 17.5H6.38333L11.8433 2.5H13.6167L8.15667 17.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DataEntry = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_452_48528)">
        <path
          d="M20 0H4.00001C3.03559 0 2.11066 0.395088 1.42871 1.09835C0.746763 1.80161 0.363647 2.75544 0.363647 3.75V20.25C0.363647 21.2446 0.746763 22.1984 1.42871 22.9016C2.11066 23.6049 3.03559 24 4.00001 24H20C20.9644 24 21.8894 23.6049 22.5713 22.9016C23.2533 22.1984 23.6364 21.2446 23.6364 20.25V3.75C23.6364 2.75544 23.2533 1.80161 22.5713 1.09835C21.8894 0.395088 20.9644 0 20 0ZM4.00001 1.5H20C20.5787 1.5 21.1336 1.73705 21.5428 2.15901C21.952 2.58097 22.1818 3.15326 22.1818 3.75V6H1.81819V3.75C1.81819 3.15326 2.04806 2.58097 2.45723 2.15901C2.8664 1.73705 3.42136 1.5 4.00001 1.5ZM1.81819 20.25V7.5H7.63637V22.5H4.00001C3.42136 22.5 2.8664 22.2629 2.45723 21.841C2.04806 21.419 1.81819 20.8467 1.81819 20.25ZM20 22.5H9.09092V7.5H22.1818V20.25C22.1818 20.8467 21.952 21.419 21.5428 21.841C21.1336 22.2629 20.5787 22.5 20 22.5ZM3.27274 9.75C3.27274 9.55109 3.34936 9.36032 3.48575 9.21967C3.62214 9.07902 3.80713 9 4.00001 9H5.45456C5.64744 9 5.83243 9.07902 5.96882 9.21967C6.10521 9.36032 6.18183 9.55109 6.18183 9.75C6.18183 9.94891 6.10521 10.1397 5.96882 10.2803C5.83243 10.421 5.64744 10.5 5.45456 10.5H4.00001C3.80713 10.5 3.62214 10.421 3.48575 10.2803C3.34936 10.1397 3.27274 9.94891 3.27274 9.75ZM6.18183 14.25C6.18183 14.4489 6.10521 14.6397 5.96882 14.7803C5.83243 14.921 5.64744 15 5.45456 15H4.00001C3.80713 15 3.62214 14.921 3.48575 14.7803C3.34936 14.6397 3.27274 14.4489 3.27274 14.25C3.27274 14.0511 3.34936 13.8603 3.48575 13.7197C3.62214 13.579 3.80713 13.5 4.00001 13.5H5.45456C5.64744 13.5 5.83243 13.579 5.96882 13.7197C6.10521 13.8603 6.18183 14.0511 6.18183 14.25ZM6.18183 18.75C6.18183 18.9489 6.10521 19.1397 5.96882 19.2803C5.83243 19.421 5.64744 19.5 5.45456 19.5H4.00001C3.80713 19.5 3.62214 19.421 3.48575 19.2803C3.34936 19.1397 3.27274 18.9489 3.27274 18.75C3.27274 18.5511 3.34936 18.3603 3.48575 18.2197C3.62214 18.079 3.80713 18 4.00001 18H5.45456C5.64744 18 5.83243 18.079 5.96882 18.2197C6.10521 18.3603 6.18183 18.5511 6.18183 18.75ZM20.7273 9.75C20.7273 9.94891 20.6507 10.1397 20.5143 10.2803C20.3779 10.421 20.1929 10.5 20 10.5H11.2727C11.0799 10.5 10.8949 10.421 10.7585 10.2803C10.6221 10.1397 10.5455 9.94891 10.5455 9.75C10.5455 9.55109 10.6221 9.36032 10.7585 9.21967C10.8949 9.07902 11.0799 9 11.2727 9H20C20.1929 9 20.3779 9.07902 20.5143 9.21967C20.6507 9.36032 20.7273 9.55109 20.7273 9.75ZM20.7273 14.25C20.7273 14.4489 20.6507 14.6397 20.5143 14.7803C20.3779 14.921 20.1929 15 20 15H11.2727C11.0799 15 10.8949 14.921 10.7585 14.7803C10.6221 14.6397 10.5455 14.4489 10.5455 14.25C10.5455 14.0511 10.6221 13.8603 10.7585 13.7197C10.8949 13.579 11.0799 13.5 11.2727 13.5H20C20.1929 13.5 20.3779 13.579 20.5143 13.7197C20.6507 13.8603 20.7273 14.0511 20.7273 14.25ZM20.7273 18.75C20.7273 18.9489 20.6507 19.1397 20.5143 19.2803C20.3779 19.421 20.1929 19.5 20 19.5H11.2727C11.0799 19.5 10.8949 19.421 10.7585 19.2803C10.6221 19.1397 10.5455 18.9489 10.5455 18.75C10.5455 18.5511 10.6221 18.3603 10.7585 18.2197C10.8949 18.079 11.0799 18 11.2727 18H20C20.1929 18 20.3779 18.079 20.5143 18.2197C20.6507 18.3603 20.7273 18.5511 20.7273 18.75Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clippath id="clip0_452_48528">
          <rect
            width="23.2727"
            height="24"
            fill="white"
            transform="translate(0.363647)"
          />
        </clippath>
      </defs>
    </svg>
  );
};

export const DataSelection = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M2 18C2 16.1144 2 15.1716 2.58579 14.5858C3.17157 14 4.11438 14 6 14H18C19.8856 14 20.8284 14 21.4142 14.5858C22 15.1716 22 16.1144 22 18C22 19.8856 22 20.8284 21.4142 21.4142C20.8284 22 19.8856 22 18 22H6C4.11438 22 3.17157 22 2.58579 21.4142C2 20.8284 2 19.8856 2 18Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M2 7C2 5.11438 2 4.17157 2.58579 3.58579C3.17157 3 4.11438 3 6 3H18C19.8856 3 20.8284 3 21.4142 3.58579C22 4.17157 22 5.11438 22 7C22 8.88562 22 9.82843 21.4142 10.4142C20.8284 11 19.8856 11 18 11H6C4.11438 11 3.17157 11 2.58579 10.4142C2 9.82843 2 8.88562 2 7Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M11 7H18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6 7H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M11 18H18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6 18H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const MultipleSelection = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.4649 7.51093C17.1768 7.22752 16.7146 7.22783 16.4269 7.51162L12.6506 11.2367C12.2623 11.6198 11.6387 11.621 11.2489 11.2396L10.5708 10.5761C10.282 10.2935 9.81984 10.295 9.53294 10.5795C9.23991 10.8702 9.2415 11.3444 9.53648 11.6331L11.2531 13.3129C11.6429 13.6943 12.2665 13.6931 12.6547 13.3101L17.4656 8.56459C17.7594 8.27472 17.7591 7.80041 17.4649 7.51093Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 2C5.67157 2 5 2.67157 5 3.5V17.5C5 18.3284 5.67157 19 6.5 19H20.5C21.3284 19 22 18.3284 22 17.5V3.5C22 2.67157 21.3284 2 20.5 2H6.5ZM20.4062 4.59375C20.4062 4.04147 19.9585 3.59375 19.4062 3.59375H7.59375C7.04147 3.59375 6.59375 4.04147 6.59375 4.59375V16.4062C6.59375 16.9585 7.04147 17.4062 7.59375 17.4062H19.4062C19.9585 17.4062 20.4062 16.9585 20.4062 16.4062V4.59375Z"
        fill="currentColor"
      />
      <path
        d="M2 5.79688C2 5.35677 2.35677 5 2.79688 5C3.23698 5 3.59375 5.35677 3.59375 5.79687V19.4062C3.59375 19.9585 4.04147 20.4062 4.59375 20.4062H18.2031C18.6432 20.4062 19 20.763 19 21.2031C19 21.6432 18.6432 22 18.2031 22H4C2.89543 22 2 21.1046 2 20V5.79688Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Survey = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.5 6.5H13.375M6.5 12H17.5M6.5 17.5H10.625M5.4 1H18.6C20.1401 1 20.9103 1 21.4985 1.29974C22.0159 1.56338 22.4367 1.98407 22.7003 2.50153C23 3.08978 23 3.85986 23 5.4V18.6C23 20.1401 23 20.9103 22.7003 21.4985C22.4367 22.0159 22.0159 22.4367 21.4985 22.7003C20.9103 23 20.1401 23 18.6 23H5.4C3.85986 23 3.08978 23 2.50153 22.7003C1.98407 22.4367 1.56338 22.0159 1.29974 21.4985C1 20.9103 1 20.1401 1 18.6V5.4C1 3.85986 1 3.08978 1.29974 2.50153C1.56338 1.98407 1.98407 1.56338 2.50153 1.29974C3.08978 1 3.85986 1 5.4 1Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Quiz = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M9.60885 4.49512H6.86375C5.34767 4.49512 4.11865 5.72414 4.11865 7.24022V23.7108C4.11865 25.2269 5.34767 26.4559 6.86375 26.4559H20.5892C22.1054 26.4559 23.3343 25.2269 23.3343 23.7108V7.24022C23.3343 5.72414 22.1054 4.49512 20.5892 4.49512H17.8441"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7266 14.103H17.8442"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7266 19.593H17.8442"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.60791 4.4951C9.60791 2.97902 10.8369 1.75 12.353 1.75H15.0981C16.6142 1.75 17.8432 2.97902 17.8432 4.4951V7.2402H9.60791V4.4951Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.60644 15.4758C10.3645 15.4758 10.979 14.8613 10.979 14.1033C10.979 13.3452 10.3645 12.7307 9.60644 12.7307C8.8484 12.7307 8.23389 13.3452 8.23389 14.1033C8.23389 14.8613 8.8484 15.4758 9.60644 15.4758Z"
        fill="currentColor"
      />
      <path
        d="M9.60644 20.9658C10.3645 20.9658 10.979 20.3513 10.979 19.5933C10.979 18.8352 10.3645 18.2207 9.60644 18.2207C8.8484 18.2207 8.23389 18.8352 8.23389 19.5933C8.23389 20.3513 8.8484 20.9658 9.60644 20.9658Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UploadForm = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_452_48566)">
        <path
          d="M8.5 17V10M8.5 10L11 13M8.5 10L6 13"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.5 17V10M15.5 10L18 13M15.5 10L13 13"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 7H12H6"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M1 12C1 6.81455 1 4.22182 2.61092 2.61092C4.22182 1 6.81455 1 12 1C17.1854 1 19.7782 1 21.389 2.61092C23 4.22182 23 6.81455 23 12C23 17.1854 23 19.7782 21.389 21.389C19.7782 23 17.1854 23 12 23C6.81455 23 4.22182 23 2.61092 21.389C1 19.7782 1 17.1854 1 12Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clippath id="clip0_452_48566">
          <rect width="24" height="24" fill="white" />
        </clippath>
      </defs>
    </svg>
  );
};

export const SatisfactionScore = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.0001 6.25L13.1801 8.76L15.8201 9.17L13.9101 11.12L14.3601 13.89L12.0001 12.58L9.64005 13.89L10.0901 11.12L8.18005 9.17L10.8201 8.76L12.0001 6.25Z"
        fill="currentColor"
      />
      <path
        d="M18.68 1.47998H5.32C4.30687 1.47998 3.33524 1.88244 2.61885 2.59883C1.90246 3.31522 1.5 4.28685 1.5 5.29998V14.84C1.5 15.8531 1.90246 16.8247 2.61885 17.5411C3.33524 18.2575 4.30687 18.66 5.32 18.66H9.14L12 21.52L14.86 18.66H18.68C19.6931 18.66 20.6648 18.2575 21.3811 17.5411C22.0975 16.8247 22.5 15.8531 22.5 14.84V5.29998C22.5 4.28685 22.0975 3.31522 21.3811 2.59883C20.6648 1.88244 19.6931 1.47998 18.68 1.47998Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export const CheckAnswer = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8006 12.1912C20.043 12.4294 20.0648 12.8074 19.8637 13.0707L15.2337 17.8006C14.993 18.0456 14.6102 18.0649 14.3471 17.8582L11.5258 15.01C11.267 14.7481 11.2695 14.326 11.5315 14.0672C11.7732 13.8284 12.1515 13.8122 12.4118 14.0171L14.7567 16.3833L18.8579 12.1994C19.1159 11.9368 19.538 11.9331 19.8006 12.1912ZM8.66667 14C9.03486 14 9.33333 14.2985 9.33333 14.6667C9.33333 15.0349 9.03486 15.3333 8.66667 15.3333H4.66667C4.29848 15.3333 4 15.0349 4 14.6667C4 14.2985 4.29848 14 4.66667 14H8.66667ZM16.6667 10C17.0349 10 17.3333 10.2985 17.3333 10.6667C17.3333 11.0349 17.0349 11.3333 16.6667 11.3333H4.66667C4.29848 11.3333 4 11.0349 4 10.6667C4 10.2985 4.29848 10 4.66667 10H16.6667ZM16.6667 6C17.0349 6 17.3333 6.29848 17.3333 6.66667C17.3333 7.03486 17.0349 7.33333 16.6667 7.33333H4.66667C4.29848 7.33333 4 7.03486 4 6.66667C4 6.29848 4.29848 6 4.66667 6H16.6667Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ChevronRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.21967 5.71967C7.92678 6.01257 7.92678 6.48744 8.21967 6.78033L11.9393 10.5L8.21967 14.2197C7.92678 14.5126 7.92678 14.9874 8.21967 15.2803C8.51257 15.5732 8.98744 15.5732 9.28033 15.2803L13.5303 11.0303C13.8232 10.7374 13.8232 10.2625 13.5303 9.96965L9.28033 5.71967C8.98743 5.42678 8.51256 5.42678 8.21967 5.71967Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DocumentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M15.6111 4C17.1988 4 17.9622 4.14743 18.7554 4.57165C19.4748 4.95635 20.0436 5.52524 20.4284 6.24457C20.8526 7.0378 21 7.80124 21 9.38888V14.6111C21 16.1988 20.8526 16.9622 20.4284 17.7554C20.0436 18.4748 19.4748 19.0436 18.7554 19.4284C17.9622 19.8526 17.1988 20 15.6111 20H10.3889C8.80124 20 8.0378 19.8526 7.24457 19.4284C6.52524 19.0436 5.95635 18.4748 5.57165 17.7554C5.14743 16.9622 5 16.1988 5 14.6111V9.38888C5 7.80124 5.14743 7.0378 5.57165 6.24457C5.95635 5.52524 6.52524 4.95635 7.24457 4.57165C8.0378 4.14743 8.80124 4 10.3889 4H15.6111ZM15.6111 5.45455H10.3889C9.02083 5.45455 8.48423 5.55817 7.93053 5.85429C7.46468 6.10343 7.10343 6.46468 6.85429 6.93053C6.55817 7.48423 6.45455 8.02083 6.45455 9.38888V14.6111C6.45455 15.9792 6.55817 16.5158 6.85429 17.0695C7.10343 17.5353 7.46468 17.8966 7.93053 18.1457C8.48423 18.4418 9.02083 18.5455 10.3889 18.5455H15.6111C16.9792 18.5455 17.5158 18.4418 18.0695 18.1457C18.5353 17.8966 18.8966 17.5353 19.1457 17.0695C19.4418 16.5158 19.5455 15.9792 19.5455 14.6111V9.38888C19.5455 8.02083 19.4418 7.48423 19.1457 6.93053C18.8966 6.46468 18.5353 6.10343 18.0695 5.85429C17.5158 5.55817 16.9792 5.45455 15.6111 5.45455ZM12.2727 14.5455C12.6744 14.5455 13 14.8711 13 15.2727C13 15.6744 12.6744 16 12.2727 16H9.36364C8.96197 16 8.63636 15.6744 8.63636 15.2727C8.63636 14.8711 8.96197 14.5455 9.36364 14.5455H12.2727ZM16.6364 11.2727C17.038 11.2727 17.3636 11.5983 17.3636 12C17.3636 12.4017 17.038 12.7273 16.6364 12.7273H9.36364C8.96197 12.7273 8.63636 12.4017 8.63636 12C8.63636 11.5983 8.96197 11.2727 9.36364 11.2727H16.6364ZM16.6364 8C17.038 8 17.3636 8.32561 17.3636 8.72727C17.3636 9.12893 17.038 9.45455 16.6364 9.45455H9.36364C8.96197 9.45455 8.63636 9.12893 8.63636 8.72727C8.63636 8.32561 8.96197 8 9.36364 8H16.6364Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ManageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.00024 3.67871C7.92261 3.67871 7.00429 4.38094 6.65649 5.34538H4.83358C4.37334 5.34538 4.00024 5.71848 4.00024 6.17871C4.00024 6.63894 4.37334 7.01204 4.83358 7.01204H6.65487C7.00224 7.97726 7.92205 8.67871 9.00024 8.67871C10.0779 8.67871 10.9962 7.97649 11.344 7.01204H19.8336C20.2938 7.01204 20.6669 6.63894 20.6669 6.17871C20.6669 5.71848 20.2938 5.34538 19.8336 5.34538H11.344C10.9962 4.38094 10.0779 3.67871 9.00024 3.67871ZM9.00024 5.34538C9.47035 5.34538 9.83358 5.7086 9.83358 6.17871C9.83358 6.64882 9.47035 7.01204 9.00024 7.01204C8.53014 7.01204 8.16691 6.64882 8.16691 6.17871C8.16691 5.7086 8.53014 5.34538 9.00024 5.34538Z"
        fill="currentColor"
      />
      <path
        d="M14.8336 9.51208C13.7559 9.51208 12.8376 10.2143 12.4898 11.1788H4.83358C4.37334 11.1788 4.00024 11.5518 4.00024 12.0121C4.00024 12.4723 4.37334 12.8454 4.83358 12.8454H12.4882C12.8356 13.8106 13.7554 14.5121 14.8336 14.5121C15.9112 14.5121 16.8295 13.8099 17.1773 12.8454H19.8336C20.2938 12.8454 20.6669 12.4723 20.6669 12.0121C20.6669 11.5518 20.2938 11.1788 19.8336 11.1788H17.1773C16.8295 10.2143 15.9112 9.51208 14.8336 9.51208ZM14.8336 11.1788C15.3037 11.1788 15.6669 11.542 15.6669 12.0121C15.6669 12.4822 15.3037 12.8454 14.8336 12.8454C14.3635 12.8454 14.0002 12.4822 14.0002 12.0121C14.0002 11.542 14.3635 11.1788 14.8336 11.1788Z"
        fill="currentColor"
      />
      <path
        d="M9.00024 15.3453C7.92261 15.3453 7.00429 16.0476 6.65649 17.012H4.83358C4.37334 17.012 4.00024 17.3851 4.00024 17.8453C4.00024 18.3056 4.37334 18.6787 4.83358 18.6787H6.65649C7.00429 19.6431 7.92261 20.3453 9.00024 20.3453C10.0784 20.3453 10.9982 19.6439 11.3456 18.6787H19.8336C20.2938 18.6787 20.6669 18.3056 20.6669 17.8453C20.6669 17.3851 20.2938 17.012 19.8336 17.012H11.344C10.9962 16.0476 10.0779 15.3453 9.00024 15.3453ZM9.00024 17.012C9.47035 17.012 9.83358 17.3752 9.83358 17.8453C9.83358 18.3154 9.47035 18.6787 9.00024 18.6787C8.53014 18.6787 8.16691 18.3154 8.16691 17.8453C8.16691 17.3752 8.53014 17.012 9.00024 17.012Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const DateIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M14.0716 0.714355C14.4661 0.714355 14.7859 1.03415 14.7859 1.42864L14.7864 2.25708C15.3863 2.35253 15.7747 2.5067 16.1649 2.71535C16.8633 3.08887 17.4114 3.63699 17.7849 4.3354C18.1243 4.96992 18.3195 5.59976 18.3524 7.14226L18.3574 7.14293V12.3632L18.3535 12.7989C18.3244 14.3844 18.1286 15.0222 17.7849 15.6647C17.4114 16.3632 16.8633 16.9113 16.1649 17.2848C15.4665 17.6583 14.7737 17.8572 12.8633 17.8572H8.13711L7.70136 17.8534C6.11583 17.8243 5.47808 17.6284 4.83554 17.2848C4.13713 16.9113 3.58901 16.3632 3.21549 15.6647C2.85692 14.9943 2.65926 14.329 2.64402 12.5867L2.64307 7.63697V7.14293C2.68092 5.59976 2.87615 4.96992 3.21549 4.3354C3.58901 3.63699 4.13713 3.08887 4.83554 2.71535C5.22586 2.50661 5.61441 2.3524 6.21472 2.25697L6.2145 1.42864C6.2145 1.03415 6.53429 0.714355 6.92878 0.714355C7.32327 0.714355 7.64307 1.03415 7.64307 1.42864L7.6424 2.1479C7.79774 2.14459 7.96233 2.14293 8.13711 2.14293H12.8633C13.0384 2.14293 13.2032 2.1446 13.3587 2.14792L13.3574 1.42864C13.3574 1.03415 13.6771 0.714355 14.0716 0.714355ZM16.9281 8.5715H4.07164L4.0723 12.5653L4.07862 12.9716C4.10639 14.0482 4.22014 14.5141 4.47523 14.991C4.7156 15.4405 5.05979 15.7847 5.50925 16.0251C6.04234 16.3102 6.5616 16.4187 7.935 16.428H13.0654L13.4717 16.4217C14.5483 16.3939 15.0142 16.2801 15.4912 16.0251C15.9406 15.7847 16.2848 15.4405 16.5252 14.991C16.8103 14.4579 16.9188 13.9387 16.9281 12.5653L16.9281 8.5715ZM14.1045 12.1429C14.4136 12.1429 14.657 12.2009 14.8607 12.3099C15.0644 12.4188 15.2243 12.5787 15.3333 12.7824C15.4422 12.9861 15.5002 13.2295 15.5002 13.5386V13.6044C15.5002 13.9135 15.4422 14.1569 15.3333 14.3606C15.2243 14.5643 15.0644 14.7242 14.8607 14.8331C14.657 14.9421 14.4136 15.0001 14.1045 15.0001H14.0388C13.7296 15.0001 13.4862 14.9421 13.2825 14.8331C13.0788 14.7242 12.919 14.5643 12.81 14.3606C12.7011 14.1569 12.6431 13.9135 12.6431 13.6044V13.5386C12.6431 13.2295 12.7011 12.9861 12.81 12.7824C12.919 12.5787 13.0788 12.4188 13.2825 12.3099C13.4862 12.2009 13.7296 12.1429 14.0388 12.1429H14.1045ZM13.0654 3.57216H7.935L7.64307 3.57578V4.28578C7.64307 4.68027 7.32327 5.00007 6.92878 5.00007C6.53429 5.00007 6.2145 4.68027 6.2145 4.28578L6.21396 3.70901C5.94204 3.7718 5.7268 3.85874 5.50925 3.97509C5.05979 4.21546 4.7156 4.55966 4.47523 5.00911C4.21135 5.50251 4.09872 5.98407 4.07605 7.14196L16.9238 7.14293L16.9218 7.02854C16.894 5.95199 16.7803 5.48608 16.5252 5.00911C16.2848 4.55966 15.9406 4.21546 15.4912 3.97509C15.2737 3.85877 15.0585 3.77184 14.7867 3.70905L14.7859 4.28578C14.7859 4.68027 14.4661 5.00007 14.0716 5.00007C13.6771 5.00007 13.3574 4.68027 13.3574 4.28578L13.359 3.57593C13.2657 3.5741 13.1679 3.57285 13.0654 3.57216Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const CompleteIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.5" width="32" height="32" rx="16" fill="#019E5C" />
      <path d="M22 12L13.75 20.25L10 16.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0L24 0 24 24 0 24z" />
        <path
          fill="#657489"
          d="M12 10.586L16.95 5.636 18.364 7.05 13.414 12 18.364 16.95 16.95 18.364 12 13.414 7.05 18.364 5.636 16.95 10.586 12 5.636 7.05 7.05 5.636z"
        />
      </g>
    </svg>
  )
}

export const CaretUpIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M8.96868 6.50001C8.90287 6.50039 8.83764 6.48778 8.77672 6.46289C8.71581 6.43801 8.6604 6.40135 8.61368 6.35501L5.99868 3.74501L3.38368 6.36001C3.33885 6.41235 3.2837 6.45486 3.22166 6.48487C3.15963 6.51488 3.09206 6.53175 3.0232 6.53441C2.95435 6.53707 2.88568 6.52547 2.82152 6.50033C2.75735 6.47519 2.69908 6.43706 2.65035 6.38833C2.60163 6.33961 2.5635 6.28133 2.53836 6.21717C2.51322 6.15301 2.50162 6.08434 2.50428 6.01548C2.50694 5.94662 2.5238 5.87906 2.55382 5.81702C2.58383 5.75499 2.62634 5.69983 2.67868 5.65501L5.64368 2.68501C5.69016 2.63814 5.74546 2.60095 5.80639 2.57556C5.86732 2.55018 5.93267 2.53711 5.99868 2.53711C6.06468 2.53711 6.13004 2.55018 6.19097 2.57556C6.2519 2.60095 6.3072 2.63814 6.35368 2.68501L9.31868 5.65501C9.4118 5.74869 9.46407 5.87542 9.46407 6.00751C9.46407 6.1396 9.4118 6.26633 9.31868 6.36001C9.22474 6.45055 9.09914 6.50079 8.96868 6.50001Z"
        fill="currentColor"
      />
      <path
        opacity="0.3"
        d="M6 9.50004C5.86739 9.50004 5.74021 9.44736 5.64645 9.35359C5.55268 9.25982 5.5 9.13265 5.5 9.00004V3.04004C5.5 2.90743 5.55268 2.78025 5.64645 2.68649C5.74021 2.59272 5.86739 2.54004 6 2.54004C6.13261 2.54004 6.25979 2.59272 6.35355 2.68649C6.44732 2.78025 6.5 2.90743 6.5 3.04004V9.00004C6.5 9.13265 6.44732 9.25982 6.35355 9.35359C6.25979 9.44736 6.13261 9.50004 6 9.50004Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const CaretDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M8.96868 6.50001C8.90287 6.50039 8.83764 6.48778 8.77672 6.46289C8.71581 6.43801 8.6604 6.40135 8.61368 6.35501L5.99868 3.74501L3.38368 6.36001C3.33885 6.41235 3.2837 6.45486 3.22166 6.48487C3.15963 6.51488 3.09206 6.53175 3.0232 6.53441C2.95435 6.53707 2.88568 6.52547 2.82152 6.50033C2.75735 6.47519 2.69908 6.43706 2.65035 6.38833C2.60163 6.33961 2.5635 6.28133 2.53836 6.21717C2.51322 6.15301 2.50162 6.08434 2.50428 6.01548C2.50694 5.94662 2.5238 5.87906 2.55382 5.81702C2.58383 5.75499 2.62634 5.69983 2.67868 5.65501L5.64368 2.68501C5.69016 2.63814 5.74546 2.60095 5.80639 2.57556C5.86732 2.55018 5.93267 2.53711 5.99868 2.53711C6.06468 2.53711 6.13004 2.55018 6.19097 2.57556C6.2519 2.60095 6.3072 2.63814 6.35368 2.68501L9.31868 5.65501C9.4118 5.74869 9.46407 5.87542 9.46407 6.00751C9.46407 6.1396 9.4118 6.26633 9.31868 6.36001C9.22474 6.45055 9.09914 6.50079 8.96868 6.50001Z"
        fill="currentColor"
      />
      <path
        opacity="0.3"
        d="M6 9.50004C5.86739 9.50004 5.74021 9.44736 5.64645 9.35359C5.55268 9.25982 5.5 9.13265 5.5 9.00004V3.04004C5.5 2.90743 5.55268 2.78025 5.64645 2.68649C5.74021 2.59272 5.86739 2.54004 6 2.54004C6.13261 2.54004 6.25979 2.59272 6.35355 2.68649C6.44732 2.78025 6.5 2.90743 6.5 3.04004V9.00004C6.5 9.13265 6.44732 9.25982 6.35355 9.35359C6.25979 9.44736 6.13261 9.50004 6 9.50004Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const CaretRightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6.53333 13.825L10.35 10L6.53332 6.175L7.70832 5L12.7083 10L7.70833 15L6.53333 13.825Z"
        fill="#64748B"
      />
    </svg>
  )
}

export const RefreshIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.97292 8.00007C1.97292 4.97607 4.33025 1.9734 7.99958 1.9734C10.9628 1.9734 12.4284 4.16647 13.0524 5.33341H11.1996C11.0581 5.33341 10.9225 5.3896 10.8225 5.48961C10.7224 5.58963 10.6663 5.72529 10.6663 5.86674C10.6663 6.00819 10.7224 6.14384 10.8225 6.24386C10.9225 6.34388 11.0581 6.40007 11.1996 6.40007H14.3996C14.541 6.40007 14.6767 6.34388 14.7767 6.24386C14.8767 6.14384 14.9329 6.00819 14.9329 5.86674V2.66674C14.9329 2.52529 14.8767 2.38963 14.7767 2.28961C14.6767 2.1896 14.541 2.1334 14.3996 2.1334C14.2581 2.1334 14.1225 2.1896 14.0225 2.28961C13.9224 2.38963 13.8663 2.52529 13.8663 2.66674V4.60061C13.1153 3.27581 11.3767 0.906738 7.99958 0.906738C3.66572 0.906738 0.90625 4.46407 0.90625 8.00007C0.90625 11.5361 3.66572 15.0934 7.99958 15.0934C10.0732 15.0934 11.7991 14.2721 13.0279 13.0219C13.6799 12.3569 14.1971 11.572 14.5511 10.7105C14.5777 10.6457 14.5913 10.5763 14.5911 10.5063C14.5909 10.4362 14.5769 10.3669 14.5499 10.3023C14.5229 10.2376 14.4834 10.179 14.4337 10.1296C14.3841 10.0802 14.3252 10.0411 14.2604 10.0145C14.1956 9.98786 14.1262 9.97426 14.0562 9.97447C13.9861 9.97467 13.9168 9.98867 13.8522 10.0157C13.7876 10.0426 13.7289 10.0821 13.6795 10.1318C13.6301 10.1814 13.591 10.2404 13.5644 10.3051C13.263 11.039 12.8225 11.7076 12.2673 12.2742C11.2316 13.3302 9.77558 14.0267 7.99958 14.0267C4.33025 14.0267 1.97292 11.0241 1.97292 8.00007Z"
        fill="currentColor"
      />
    </svg>
  )
}
